import config from 'config';
import { addMinutes, isAfter } from 'date-fns';
import cloneDeep from 'lodash/cloneDeep';
import Router from 'next/router';

import { splitTest } from '../../../react-abtest';
import {
  invalidateMembership,
  invalidateMembershipPeriod,
  invalidateProfile,
  loadMembership,
  loadMembershipPeriod,
  loadProfile,
  getMembership,
  getMembershipPeriod,
  updateCustomerDetail,
  getCustomerDetail,
  updateMembershipStatusSuccess,
  signUp as baseSignUp,
  loadCustomerDetails,
} from '../../../react-accounts';
import { loadAssets } from '../../../react-assets';
import { invalidateCart } from '../../../react-cart';
import { invalidateNavs } from '../../../react-navigation';
import { ProductType } from '../../../react-products';
import { loadPromos } from '../../../react-promos';
import {
  getDateNowFunction,
  getNewDateFunction,
  getSession,
} from '../../../redux-core';
import { SignUpMethod } from '../constants';
import {
  MembershipActionLocation,
  MembershipEventAction,
} from '../constants/checkout';
import { ReviewSortCategories } from '../constants/reviews';
import {
  getShippingInfo,
  getPaymentInfo,
  getDefaultAddress,
  getDefaultPaymentMethod,
  getFilteredShippingOptions,
  getMembershipCartItem,
  hasFreeTrialMembershipInCart,
  isUnlockedXclusiveProductVisible as getIsUnlockedXclusiveProductVisible,
  getDefaultMembershipProductId,
  hasOnlyMembershipCartItem,
  hasPromoConflict,
  isVipLiveShoppingPromoAppliedSelector,
  getGwpPromo,
  getStateDependentProductFilters,
} from '../selectors/selectors';
import {
  filtersToRequestParams,
  requestParamsToStoreKey,
  requestParamsToRequestKey,
  requestParamsToAggregationKey,
} from '../utils/productBrowser';
import { validateShippingOption } from '../utils/validateShipping';

import * as checkoutFunctions from './index';

export const GET_AFTERPAY_TOKEN = 'GET_AFTERPAY_TOKEN';
export const GET_AFTERPAY_TOKEN_SUCCESS = 'GET_AFTERPAY_TOKEN_SUCCESS';
export const GET_AFTERPAY_TOKEN_FAILURE = 'GET_AFTERPAY_TOKEN_FAILURE';

export const GET_KLARNA_TOKEN = 'GET_KLARNA_TOKEN';
export const GET_KLARNA_TOKEN_SUCCESS = 'GET_KLARNA_TOKEN_SUCCESS';
export const GET_KLARNA_TOKEN_FAILURE = 'GET_KLARNA_TOKEN_FAILURE';

export const GET_CASHAPP_TOKEN = 'GET_CASHAPP_TOKEN';
export const GET_CASHAPP_TOKEN_SUCCESS = 'GET_CASHAPP_TOKEN_SUCCESS';
export const GET_CASHAPP_TOKEN_FAILURE = 'GET_CASHAPP_TOKEN_FAILURE';

export const CHECKOUT_AFTERPAY_REQUEST = 'CHECKOUT_AFTERPAY_REQUEST';
export const CHECKOUT_AFTERPAY_SUCCESS = 'CHECKOUT_AFTERPAY_SUCCESS';
export const CHECKOUT_AFTERPAY_FAILURE = 'CHECKOUT_AFTERPAY_FAILURE';

export const CHECKOUT_CASH_APP_REQUEST = 'CHECKOUT_CASH_APP_REQUEST';
export const CHECKOUT_CASH_APP_SUCCESS = 'CHECKOUT_CASH_APP_SUCCESS';
export const CHECKOUT_CASH_APP_FAILURE = 'CHECKOUT_CASH_APP_FAILURE';

export const LOAD_WAITLIST_REQUEST = 'LOAD_WAITLIST_REQUEST';
export const LOAD_WAITLIST_SUCCESS = 'LOAD_WAITLIST_SUCCESS';
export const LOAD_WAITLIST_FAILURE = 'LOAD_WAITLIST_FAILURE';

export const SHIPPING_PROVIDER_LOCATIONS_REQUEST =
  'SHIPPING_PROVIDER_LOCATIONS_REQUEST';
export const SHIPPING_PROVIDER_LOCATIONS_SUCCESS =
  'SHIPPING_PROVIDER_LOCATIONS_SUCCESS';
export const SHIPPING_PROVIDER_LOCATIONS_FAILURE =
  'SHIPPING_PROVIDER_LOCATIONS_FAILURE';

export const LOAD_CART_REQUEST = 'LOAD_CART_REQUEST';
export const LOAD_CART_SUCCESS = 'LOAD_CART_SUCCESS';
export const LOAD_CART_FAILURE = 'LOAD_CART_FAILURE';

export const SWEEP_CART_REQUEST = 'SWEEP_CART_REQUEST';
export const SWEEP_CART_SUCCESS = 'SWEEP_CART_SUCCESS';
export const SWEEP_CART_FAILIURE = 'SWEEP_CART_FAILURE';

export const LOAD_CART_ITEM_COUNT_REQUEST = 'LOAD_CART_ITEM_COUNT_REQUEST';
export const LOAD_CART_ITEM_COUNT_SUCCESS = 'LOAD_CART_ITEM_COUNT_SUCCESS';
export const LOAD_CART_ITEM_COUNT_FAILURE = 'LOAD_CART_ITEM_COUNT_FAILURE';

export const LOAD_BRAINTREE_REQUEST = 'LOAD_BRAINTREE_REQUEST';
export const LOAD_BRAINTREE_SUCCESS = 'LOAD_BRAINTREE_SUCCESS';
export const LOAD_BRAINTREE_FAILURE = 'LOAD_BRAINTREE_FAILURE';

export const SET_BRAINTREE_DEVICE_DATA = 'SET_BRAINTREE_DEVICE_DATA';

export const ADD_PRODUCT_SET_REQUEST = 'ADD_PRODUCT_SET_REQUEST';
export const ADD_PRODUCT_SET_SUCCESS = 'ADD_PRODUCT_SET_SUCCESS';
export const ADD_PRODUCT_SET_FAILURE = 'ADD_PRODUCT_SET_FAILURE';

export const DELETE_PRODUCT_SET_REQUEST = 'DELETE_PRODUCT_SET_REQUEST';
export const DELETE_PRODUCT_SET_SUCCESS = 'DELETE_PRODUCT_SET_SUCCESS';
export const DELETE_PRODUCT_SET_FAILURE = 'DELETE_PRODUCT_SET_FAILURE';

export const ADD_BASKET_ITEMS_REQUEST = 'ADD_BASKET_ITEMS_REQUEST';
export const ADD_BASKET_ITEMS_SUCCESS = 'ADD_BASKET_ITEMS_SUCCESS';
export const ADD_BASKET_ITEMS_FAILURE = 'ADD_BASKET_ITEMS_FAILURE';

export const ADD_FIRST_BYO_ITEM_REQUEST = 'ADD_FIRST_BYO_ITEM_REQUEST';
export const ADD_FIRST_BYO_ITEM_SUCCESS = 'ADD_FIRST_BYO_ITEM_SUCCESS';
export const ADD_FIRST_BYO_ITEM_FAILURE = 'ADD_FIRST_BYO_ITEM_FAILURE';

export const ADD_BYO_ITEM_REQUEST = 'ADD_BYO_ITEM_REQUEST';
export const ADD_BYO_ITEM_SUCCESS = 'ADD_BYO_ITEM_SUCCESS';
export const ADD_BYO_ITEM_FAILURE = 'ADD_BYO_ITEM_FAILURE';

export const DELETE_BASKET_ITEMS_REQUEST = 'DELETE_BASKET_ITEMS_REQUEST';
export const DELETE_BASKET_ITEMS_SUCCESS = 'DELETE_BASKET_ITEMS_SUCCESS';
export const DELETE_BASKET_ITEMS_FAILURE = 'DELETE_BASKET_ITEMS_FAILURE';

export const DELETE_BASKET_ITEMS_BY_PRODUCT_ID_REQUEST =
  'DELETE_BASKET_ITEMS_BY_PRODUCT_ID_REQUEST';
export const DELETE_BASKET_ITEMS_BY_PRODUCT_ID_SUCCESS =
  'DELETE_BASKET_ITEMS_BY_PRODUCT_ID_SUCCESS';
export const DELETE_BASKET_ITEMS_BY_PRODUCT_ID_FAILURE =
  'DELETE_BASKET_ITEMS_BY_PRODUCT_ID_FAILURE';

export const DELETE_MEMBERSHIP_ITEM_REQUEST = 'DELETE_MEMBERSHIP_ITEM_REQUEST';
export const DELETE_MEMBERSHIP_ITEM_SUCCESS = 'DELETE_MEMBERSHIP_ITEM_SUCCESS';
export const DELETE_MEMBERSHIP_ITEM_FAILURE = 'DELETE_MEMBERSHIP_ITEM_FAILURE';

export const UPDATE_CART_LINE_ITEM_REQUEST = 'UPDATE_CART_LINE_ITEM_REQUEST';
export const UPDATE_CART_LINE_ITEM_SUCCESS = 'UPDATE_CART_LINE_ITEM_SUCCESS';
export const UPDATE_CART_LINE_ITEM_FAILURE = 'UPDATE_CART_LINE_ITEM_FAILURE';

export const UPDATE_ITEM_QUANTITY_REQUEST = 'UPDATE_ITEM_QUANTITY_REQUEST';
export const UPDATE_ITEM_QUANTITY_SUCCESS = 'UPDATE_ITEM_QUANTITY_SUCCESS';
export const UPDATE_ITEM_QUANTITY_FAILURE = 'UPDATE_ITEM_QUANTITY_FAILURE';

export const UPDATE_CART_ITEM_REQUEST = 'UPDATE_CART_ITEM_REQUEST';
export const UPDATE_CART_ITEM_SUCCESS = 'UPDATE_CART_ITEM_SUCCESS';
export const UPDATE_CART_ITEM_FAILURE = 'UPDATE_CART_ITEM_FAILURE';
export const UPDATE_CART_ITEMS_SUCCESS = 'UPDATE_CART_ITEMS_SUCCESS';

export const LOAD_CANCEL_REASONS_REQUEST = 'LOAD_CANCEL_REASONS_REQUEST';
export const LOAD_CANCEL_REASONS_SUCCESS = 'LOAD_CANCEL_REASONS_SUCCESS';
export const LOAD_CANCEL_REASONS_FAILURE = 'LOAD_CANCEL_REASONS_FAILURE';

export const LOAD_REVIEWABLE_PRODUCTS_DETAILS_REQUEST =
  'LOAD_REVIEWABLE_PRODUCTS_DETAILS_REQUEST';
export const LOAD_REVIEWABLE_PRODUCTS_DETAILS_SUCCESS =
  'LOAD_REVIEWABLE_PRODUCTS_DETAILS_SUCCESS';
export const LOAD_REVIEWABLE_PRODUCTS_DETAILS_FAILURE =
  'LOAD_REVIEWABLE_PRODUCTS_DETAILS_FAILURE';

export const LOAD_REVIEWABLE_PRODUCTS_REQUEST =
  'LOAD_REVIEWABLE_PRODUCTS_REQUEST';
export const LOAD_REVIEWABLE_PRODUCTS_SUCCESS =
  'LOAD_REVIEWABLE_PRODUCTS_SUCCESS';
export const LOAD_REVIEWABLE_PRODUCTS_FAILURE =
  'LOAD_REVIEWABLE_PRODUCTS_FAILURE';

export const PAUSE_MEMBERSHIP_REQUEST = 'PAUSE_MEMBERSHIP_REQUEST';
export const PAUSE_MEMBERSHIP_SUCCESS = 'PAUSE_MEMBERSHIP_SUCCESS';
export const PAUSE_MEMBERSHIP_FAILURE = 'PAUSE_MEMBERSHIP_FAILURE';

export const UPDATE_SET_ITEM_QUANTITY_REQUEST =
  'UPDATE_SET_ITEM_QUANTITY_REQUEST';
export const UPDATE_SET_ITEM_QUANTITY_SUCCESS =
  'UPDATE_SET_ITEM_QUANTITY_SUCCESS';
export const UPDATE_SET_ITEM_QUANTITY_FAILURE =
  'UPDATE_SET_ITEM_QUANTITY_FAILURE';

export const UPDATE_FULFILLMENT_PROVIDER_REQUEST = `UPDATE_FULFILLMENT_PROVIDER_REQUEST`;
export const UPDATE_FULFILLMENT_PROVIDER_SUCCESS = `UPDATE_FULFILLMENT_PROVIDER_SUCCESS`;
export const UPDATE_FULFILLMENT_PROVIDER_FAILURE = `UPDATE_FULFILLMENT_PROVIDER_FAILURE`;

export const UPDATE_CART_WITH_ADDRESS_REQUEST =
  'UPDATE_CART_WITH_ADDRESS_REQUEST';
export const UPDATE_CART_WITH_ADDRESS_SUCCESS =
  'UPDATE_CART_WITH_ADDRESS_SUCCESS';
export const UPDATE_CART_WITH_ADDRESS_FAILURE =
  'UPDATE_CART_WITH_ADDRESS_FAILURE';

export const UPDATE_CART_WITH_PAYMENT_REQUEST =
  'UPDATE_CART_WITH_PAYMENT_REQUEST';
export const UPDATE_CART_WITH_PAYMENT_SUCCESS =
  'UPDATE_CART_WITH_PAYMENT_SUCCESS';
export const UPDATE_CART_WITH_PAYMENT_FAILURE =
  'UPDATE_CART_WITH_PAYMENT_FAILURE';

export const UPDATE_CART_WITH_SHIPPING_REQUEST =
  'UPDATE_CART_WITH_SHIPPING_REQUEST';
export const UPDATE_CART_WITH_SHIPPING_SUCCESS =
  'UPDATE_CART_WITH_SHIPPING_SUCCESS';
export const UPDATE_CART_WITH_SHIPPING_FAILURE =
  'UPDATE_CART_WITH_SHIPPING_FAILURE';

export const GET_SHIPPING_OPTIONS_REQUEST = 'GET_SHIPPING_OPTIONS_REQUEST';
export const GET_SHIPPING_OPTIONS_SUCCESS = 'GET_SHIPPING_OPTIONS_SUCCESS';
export const GET_SHIPPING_OPTIONS_FAILURE = 'GET_SHIPPING_OPTIONS_FAILURE';

export const SAVE_MONDIAL_ADDRESS_REQUEST = 'SAVE_MONDIAL_ADDRESS_REQUEST';
export const SAVE_MONDIAL_ADDRESS_SUCCESS = 'SAVE_MONDIAL_ADDRESS_SUCCESS';
export const SAVE_MONDIAL_ADDRESS_FAILURE = 'SAVE_MONDIAL_ADDRESS_FAILURE';

export const DELETE_MONDIAL_ADDRESS_REQUEST = 'DELETE_MONDIAL_ADDRESS_REQUEST';
export const DELETE_MONDIAL_ADDRESS_SUCCESS = 'DELETE_MONDIAL_ADDRESS_SUCCESS';
export const DELETE_MONDIAL_ADDRESS_FAILURE = 'DELETE_MONDIAL_ADDRESS_FAILURE';

export const CHANGE_DISCREET_PACKAGING_REQUEST =
  'CHANGE_DISCREET_PACKAGING_REQUEST';
export const CHANGE_DISCREET_PACKAGING_SUCCESS =
  'CHANGE_DISCREET_PACKAGING_SUCCESS';
export const CHANGE_DISCREET_PACKAGING_FAILURE =
  'CHANGE_DISCREET_PACKAGING_FAILURE';

export const SUBMIT_CART_ORDER_REQUEST = 'SUBMIT_CART_ORDER_REQUEST';
export const SUBMIT_CART_ORDER_SUCCESS = 'SUBMIT_CART_ORDER_SUCCESS';
export const SUBMIT_CART_ORDER_FAILURE = 'SUBMIT_CART_ORDER_FAILURE';

export const COMPLETE_CART_ORDER_REQUEST = 'COMPLETE_CART_ORDER_REQUEST';
export const COMPLETE_CART_ORDER_SUCCESS = 'COMPLETE_CART_ORDER_SUCCESS';
export const COMPLETE_CART_ORDER_FAILURE = 'COMPLETE_CART_ORDER_FAILURE';

export const CACHE_IN_PROGRESS_PAYMENT = 'CACHE_IN_PROGRESS_PAYMENT';
export const CLEAR_IN_PROGRESS_PAYMENT = 'CLEAR_IN_PROGRESS_PAYMENT';

export const TRACK_REGISTRATION_PROMPT_REQUEST =
  'TRACK_REGISTRATION_PROMPT_REQUEST';

export const TRACK_CHECKOUT_STEP = 'TRACK_CHECKOUT_STEP';
export const TRACK_CHECKOUT_TOGGLE_REQUEST = 'TRACK_CHECKOUT_TOGGLE_REQUEST';
export const TRACK_ADD_MEMBERSHIP_LINE = 'TRACK_ADD_MEMBERSHIP_LINE';
export const TRACK_REMOVE_MEMBERSHIP_LINE = 'TRACK_REMOVE_MEMBERSHIP_LINE';
export const TRACK_PAYMENT_METHOD_SELECTION = 'TRACK_PAYMENT_METHOD_SELECTION';
export const TRACK_EDIT_SHIPPING = 'TRACK_EDIT_SHIPPING';
export const TRACK_EDIT_PAYMENT = 'TRACK_EDIT_PAYMENT';
export const TRACK_EXPRESS_CHECKOUT_SELECTION =
  'TRACK_EXPRESS_CHECKOUT_SELECTION';
export const TRACK_AFTERPAY_SELECTED = 'TRACK_AFTERPAY_SELECTED';
export const TRACK_KLARNA_SELECTED = 'TRACK_KLARNA_SELECTED';
export const TRACK_CLAIM_GWP_CTA = 'TRACK_CLAIM_GWP_CTA';
export const TRACK_ADD_GWP = 'TRACK_ADD_GWP';
export const TRACK_REMOVE_GWP = 'TRACK_REMOVE_GWP';
export const TRACK_UNDO_GWP = 'TRACK_UNDO_GWP';
export const TRACK_ADD_TO_CART_FAILURE = 'TRACK_ADD_TO_CART_FAILURE';
export const TRACK_ADD_SET_TO_CART_FAILURE = 'TRACK_ADD_SET_TO_CART_FAILURE';
export const TRACK_SUBMIT_ORDER_FAILURE = 'TRACK_SUBMIT_ORDER_FAILURE';
export const TRACK_CHECKOUT_ERROR = 'TRACK_CHECKOUT_ERROR';

function getCustomHeaders(state) {
  const headers = {};
  if (state.borderfree?.isBorderfreeCustomer) {
    headers['x-tfg-borderfree'] = true;
  }
  return headers;
}

function getEnhancedError({ err, functionName }) {
  // if err is null or empty object
  // create a simple err object that shows which function threw this error
  if (!err || Object.keys(err).length === 0) {
    return {
      message: `Error in ${functionName}`,
    };
  }
  return err;
}

export const LOAD_ACCOUNT_PAYMENT_METHODS_REQUEST =
  'LOAD_ACCOUNT_PAYMENT_METHODS_REQUEST';
export const LOAD_ACCOUNT_PAYMENT_METHODS_SUCCESS =
  'LOAD_ACCOUNT_PAYMENT_METHODS_SUCCESS';
export const LOAD_ACCOUNT_PAYMENT_METHODS_FAILURE =
  'LOAD_ACCOUNT_PAYMENT_METHODS_FAILURE';

export function loadAccountPaymentMethods() {
  return (dispatch, getState) => {
    const { account } = getState();
    if (!account.payment.networkStatus.isLoading) {
      return dispatch({
        bentoApi: {
          endpoint: 'accounts/me/payments',
          method: 'GET',
          actions: [
            LOAD_ACCOUNT_PAYMENT_METHODS_REQUEST,
            LOAD_ACCOUNT_PAYMENT_METHODS_SUCCESS,
            LOAD_ACCOUNT_PAYMENT_METHODS_FAILURE,
          ],
        },
      });
    }
  };
}

export const DELETE_MEMBERSHIP_PROMO_CODE_REQUEST =
  'DELETE_MEMBERSHIP_PROMO_CODE_REQUEST';
export const DELETE_MEMBERSHIP_PROMO_CODE_SUCCESS =
  'DELETE_MEMBERSHIP_PROMO_CODE_SUCCESS';
export const DELETE_MEMBERSHIP_PROMO_CODE_FAILURE =
  'DELETE_MEMBERSHIP_PROMO_CODE_FAILURE';

export function deleteMembershipPromo(promoCode) {
  return {
    bentoApi: {
      endpoint: `accounts/me/membership/promo/${promoCode}`,
      method: 'DELETE',
      actions: [
        DELETE_MEMBERSHIP_PROMO_CODE_REQUEST,
        DELETE_MEMBERSHIP_PROMO_CODE_SUCCESS,
        DELETE_MEMBERSHIP_PROMO_CODE_FAILURE,
      ],
    },
  };
}

export function getAfterpayToken() {
  return async (dispatch) => {
    return dispatch({
      bentoApi: {
        endpoint: `cart/checkout/afterpay/session`,
        method: 'POST',
        actions: [
          { type: GET_AFTERPAY_TOKEN },
          (payload) => {
            return {
              type: GET_AFTERPAY_TOKEN_SUCCESS,
              payload,
            };
          },
          { type: GET_AFTERPAY_TOKEN_FAILURE },
        ],
      },
    });
  };
}

export function checkoutAfterpay(token) {
  return async (dispatch, getState) => {
    const { checkout } = getState();
    try {
      return await dispatch({
        bentoApi: {
          endpoint: `cart/checkout/afterpay`,
          method: 'POST',
          body: JSON.stringify({
            token,
          }),
          actions: [
            { type: CHECKOUT_AFTERPAY_REQUEST },
            (payload) => {
              return {
                type: CHECKOUT_AFTERPAY_SUCCESS,
                payload,
              };
            },
            (payload) => {
              return {
                type: CHECKOUT_AFTERPAY_FAILURE,
                payload,
              };
            },
          ],
        },
      });
    } catch (err) {
      // Track Afterpay checkout errors
      const enhancedError = getEnhancedError({
        err,
        functionName: 'checkoutAfterpay',
      });
      dispatch(trackCheckoutError(enhancedError, checkout?.cartId));
      throw err;
    }
  };
}

export const FREE_TRIAL_MEMBER_JOIN_EMAIL_LIST_REQUEST =
  'FREE_TRIAL_MEMBER_JOIN_EMAIL_LIST_REQUEST';
export const FREE_TRIAL_MEMBER_JOIN_EMAIL_LIST_SUCCESS =
  'FREE_TRIAL_MEMBER_JOIN_EMAIL_LIST_SUCCESS';
export const FREE_TRIAL_MEMBER_JOIN_EMAIL_LIST_FAILURE =
  'FREE_TRIAL_MEMBER_JOIN_EMAIL_LIST_FAILURE';

export function subscribeNewFreeTrialMember({ email }) {
  return async (dispatch, getState) => {
    const { domain } = getState();
    const newMemberList = config.get('public.sailthru.newFreeTrialMember');
    const marketingList = config.get('public.sailthru.marketingLists')[
      domain.tld
    ];

    const marketingLists = marketingList
      ? [marketingList, newMemberList]
      : [newMemberList];

    const result = await dispatch({
      bentoApi: {
        endpoint: 'contacts',
        method: 'POST',
        body: JSON.stringify({
          email,
          marketingLists,
        }),
        actions: [
          FREE_TRIAL_MEMBER_JOIN_EMAIL_LIST_REQUEST,
          FREE_TRIAL_MEMBER_JOIN_EMAIL_LIST_SUCCESS,
          FREE_TRIAL_MEMBER_JOIN_EMAIL_LIST_FAILURE,
        ],
      },
    });
    return result;
  };
}

export function getKlarnaToken(baseUrl, sessionId) {
  const requestBody = sessionId
    ? { redirectConfirmUrl: baseUrl, klarnaSessionId: sessionId }
    : { redirectConfirmUrl: baseUrl };
  return async (dispatch, getState) => {
    const { checkout } = getState();
    try {
      return await dispatch({
        bentoApi: {
          endpoint: `cart/checkout/klarna/session`,
          method: 'POST',
          body: JSON.stringify(requestBody),
          actions: [
            { type: GET_KLARNA_TOKEN },
            (payload) => {
              return {
                type: GET_KLARNA_TOKEN_SUCCESS,
                payload,
              };
            },
            (payload) => {
              localStorage.removeItem('klarnaSession');
              // Still track the error even though we're cleaning up localStorage

              dispatch(trackCheckoutError(payload, checkout?.cartId));
              return {
                type: GET_KLARNA_TOKEN_FAILURE,
                payload,
              };
            },
          ],
        },
      });
    } catch (err) {
      // Track Klarna token errors
      const enhancedError = getEnhancedError({
        err,
        functionName: 'getKlarnaToken',
      });
      dispatch(trackCheckoutError(enhancedError, checkout?.cartId));
      throw err;
    }
  };
}

export function getCashAppToken() {
  return {
    bentoApi: {
      endpoint: `cart/checkout/cashapppay/session`,
      method: 'POST',
      actions: [
        { type: GET_CASHAPP_TOKEN },
        (payload) => {
          return {
            type: GET_CASHAPP_TOKEN_SUCCESS,
            payload,
          };
        },
        { type: GET_CASHAPP_TOKEN_FAILURE },
      ],
    },
  };
}

export function checkoutCashApp(token) {
  return async (dispatch, getState) => {
    const { checkout } = getState();
    try {
      return await dispatch({
        bentoApi: {
          endpoint: `cart/checkout/cashapppay`,
          method: 'POST',
          body: JSON.stringify({
            token,
          }),
          actions: [
            { type: CHECKOUT_CASH_APP_REQUEST },
            (payload) => {
              return {
                type: CHECKOUT_CASH_APP_SUCCESS,
                payload,
              };
            },
            (payload) => {
              return {
                type: CHECKOUT_CASH_APP_FAILURE,
                payload,
              };
            },
          ],
        },
      });
    } catch (err) {
      // Track Cash App checkout errors
      const enhancedError = getEnhancedError({
        err,
        functionName: 'checkoutCashApp',
      });
      dispatch(trackCheckoutError(enhancedError, checkout?.cartId));
      throw err;
    }
  };
}

export function getShippingProviderLocations({ postalCode, countryCode }) {
  return (dispatch) => {
    const shippingProviderId = config.get('public.shippingProviders')[
      countryCode
    ].providerId;
    if (!shippingProviderId) {
      throw new Error('Missing providerId in getShippingProviderLocations');
    }
    return dispatch({
      bentoApi: {
        endpoint: `shipping/providers/${shippingProviderId}/locations?postalCode=${postalCode}&countryCode=${countryCode}`,
        method: 'GET',
        actions: [
          SHIPPING_PROVIDER_LOCATIONS_REQUEST,
          SHIPPING_PROVIDER_LOCATIONS_SUCCESS,
          SHIPPING_PROVIDER_LOCATIONS_FAILURE,
        ],
      },
    });
  };
}

export function checkVipLivePromoIsExpired() {
  return async (dispatch, getState) => {
    const state = getState();
    const getDateNow = getDateNowFunction(state);
    const isPromoApplied = isVipLiveShoppingPromoAppliedSelector(state);

    if (!isPromoApplied) {
      return;
    }

    const promoInitTime = getCustomerDetail(
      state,
      'vip_live_shopping_promo_start'
    )?.value;

    const promoDeadline = promoInitTime
      ? addMinutes(promoInitTime, 60).toISOString()
      : null;
    const isPromoExpired = promoDeadline
      ? !isAfter(new Date(promoDeadline), getDateNow())
      : false;

    if (!isPromoExpired) {
      return;
    }

    return dispatch(
      deleteMembershipPromo(
        config.get('public.promoCodes.vipLiveShopping.promoCode')
      )
    );
  };
}

export function sweepCart() {
  return async (dispatch, getState) => {
    // Hardcoded Number so it tries to make as many bundles as possible.
    const tokenQuantity = 99;
    const state = getState();
    return dispatch({
      bentoApi: {
        endpoint: `cart/byo/sweep?tokenQuantity=${tokenQuantity}&autoApplyToken=false`,
        method: 'GET',
        headers: getCustomHeaders(state),
        actions: [
          SWEEP_CART_REQUEST,
          (payload, extraMeta) => {
            return {
              type: SWEEP_CART_SUCCESS,
              meta: {
                ...extraMeta,
              },
              payload,
            };
          },
          SWEEP_CART_FAILIURE,
        ],
      },
    });
  };
}

export function loadCart(options = {}) {
  return async (dispatch, getState, context) => {
    // Importing `checkoutFunctions` for jest spying
    const { deleteExpiredGwpItems } = checkoutFunctions;

    if (options.ifNotFetched) {
      const { checkout } = getState();
      if (checkout?.fetchedDate) {
        return;
      }
    }
    let request = context.inflightCartRequest;
    const timestamp = Date.now();
    if (!context.inflightCartRequest) {
      request = dispatch({
        bentoApi: {
          endpoint: `cart?timestamp=${timestamp}`,
          method: 'GET',
          headers: getCustomHeaders(getState()),
          actions: [LOAD_CART_REQUEST, LOAD_CART_SUCCESS, LOAD_CART_FAILURE],
        },
      });
      context.inflightCartRequest = request;

      await Promise.all([request, dispatch(loadPromosIfVip())]);
      context.inflightCartRequest = null;
      await dispatch(checkVipLivePromoIsExpired());

      await Promise.all([
        dispatch(deleteExpiredGwpItems()),
        dispatch(deleteForbiddenUnlockedXclusiveProducts()),
      ]);
    }
    return request;
  };
}

export function loadCartItemCount(options = {}) {
  return async (dispatch, getState, context) => {
    if (options.ifNotFetched) {
      const { checkout } = getState();
      if (checkout?.fetchedDate) {
        return;
      }
    }
    let request = context.inflightCartItemCountRequest;
    const timestamp = Date.now();
    if (!context.inflightCartItemCountRequest) {
      request = dispatch({
        bentoApi: {
          endpoint: `cart/items/count?timestamp=${timestamp}`,
          headers: getCustomHeaders(getState()),
          method: 'GET',
          actions: [
            LOAD_CART_ITEM_COUNT_REQUEST,
            LOAD_CART_ITEM_COUNT_SUCCESS,
            LOAD_CART_ITEM_COUNT_FAILURE,
          ],
        },
      });
      context.inflightCartItemCountRequest = request;
      await request;
      context.inflightCartItemCountRequest = null;
    }
    return request;
  };
}

export function deleteExpiredGwpItems() {
  return async (dispatch, getState) => {
    const state = getState();
    const { checkout } = state;
    const gwpPromo = getGwpPromo(state);

    // Importing `checkoutFunctions` to enable jest spying
    const { deleteBasketItem } = checkoutFunctions;

    // Delete GWP items from cart if GWP promo is no longer active.
    // We're catching multiple items here in case of cart glitch

    // TODO: check this, It looks like this logic is not correct
    // it is instead removing items from other promos
    // but when changing it cartDrawer tests fall into a stack overflow error
    const gwpItems = checkout?.items.filter(
      (item) =>
        item.fplIds &&
        item.fplIds.includes(gwpPromo?.fplIds[state.domain.tld]) &&
        !(item.discount && item.discount.promoCode === gwpPromo?.promoCode)
    );

    if (!gwpItems?.length) {
      return;
    }

    const gwpItemsDeleteRequests = gwpItems?.map((gwpItem) =>
      dispatch(
        deleteBasketItem(
          gwpItem.lineId || gwpItem.cartLineId,
          MembershipActionLocation.MINI_CART,
          false
        )
      )
    );
    await Promise.all(gwpItemsDeleteRequests);
  };
}

export function deleteForbiddenUnlockedXclusiveProducts() {
  return async (dispatch, getState) => {
    const state = getState();
    const { checkout } = state;
    const membershipPeriod = getMembershipPeriod(state);
    if (!membershipPeriod.networkStatus.isUpToDate) {
      await dispatch(loadMembershipPeriod());
    }

    const isUnlockedXclusiveProductVisible =
      getIsUnlockedXclusiveProductVisible(state);

    // Importing `checkoutFunctions` to enable jest spying
    const { deleteBasketItem } = checkoutFunctions;

    // Delete Unlocked Xclusive items from cart if user is an unbilled EMP VIP.
    // We only delete one item at a time because calling `deleteBasketItem` below
    // will trigger this function again & delete the next item (if any).
    const unlockedXclusiveItemToDelete = checkout?.items.find(
      (item) =>
        !isUnlockedXclusiveProductVisible &&
        item.tagIds &&
        item.tagIds.includes(config.get('public.productTags.unlockedXclusive'))
    );

    if (!unlockedXclusiveItemToDelete) {
      return;
    }

    dispatch(
      deleteBasketItem(
        unlockedXclusiveItemToDelete.lineId ||
          unlockedXclusiveItemToDelete.cartLineId,
        MembershipActionLocation.MINI_CART,
        false
      )
    );
  };
}

export function addProductSetToCart(
  setId,
  componentProductIds,
  quantity,
  location,
  pSource,
  customText = '',
  extraBodyParams = {}
) {
  return async (dispatch, getState, context) => {
    const isBorderfreeCustomer = getState().borderfree?.isBorderfreeCustomer;
    const hadPromoConflict = hasPromoConflict(getState());
    const { isVisitor } = getSession(getState());
    const provider = isBorderfreeCustomer ? `borderfree` : `techstyle`;
    const meta = { location };
    const defaultParams = {
      setId,
      componentProductIds,
      quantity,
      provider,
      productSource: pSource,
      ...extraBodyParams,
    };
    const request = {
      bentoApi: {
        endpoint: 'cart/sets',
        method: 'POST',
        headers: getCustomHeaders(getState()),
        actions: [
          ADD_PRODUCT_SET_REQUEST,
          (payload, extraMeta) => {
            return {
              type: ADD_PRODUCT_SET_SUCCESS,
              meta: {
                setId,
                source: pSource,
                ...meta,
                ...extraMeta,
              },
              payload,
            };
          },
          ADD_PRODUCT_SET_FAILURE,
        ],
        body: JSON.stringify(
          customText
            ? {
                ...defaultParams,
                personalization: {
                  text: customText,
                },
              }
            : defaultParams
        ),
      },
    };

    let result = null;
    try {
      [result] = await Promise.all([
        dispatch(request),
        dispatch(loadPromosIfVip()),
      ]);
    } catch (err) {
      const responseBody = await err.originalError.response.json();
      const metaData = { setId, componentProductIds };
      dispatch(trackAddSetToCartFailure(responseBody || {}, metaData));
      throw responseBody;
    }

    if (!isVisitor && !isBorderfreeCustomer) {
      const hasCashPromo = hasPromoConflict(getState());
      const shouldUpdateUseStoreCredit =
        !getState().checkout?.useStoreCredit &&
        getMembership(getState()).storeCredits &&
        getMembership(getState()).storeCredits.length > 0 &&
        !hasCashPromo &&
        getState().checkout?.items.length === 1;
      /** If adding a product with cash promo but there were none before => default usestorecredit to applypromo**/
      if (!hadPromoConflict && hasCashPromo) {
        await dispatch(useStoreCredit(false));
      } else if (shouldUpdateUseStoreCredit) {
        await dispatch(useStoreCredit(true));
      }
    }
    return result;
  };
}

export function updateSetItemQuantity(groupKey, quantity, location) {
  return async (dispatch, getState, context) => {
    const meta = { location };
    return dispatch({
      bentoApi: {
        endpoint: `cart/sets/${groupKey}/quantity`,
        method: 'POST',
        headers: getCustomHeaders(getState()),
        actions: [
          UPDATE_SET_ITEM_QUANTITY_REQUEST,
          (payload, extraMeta) => {
            return {
              type: UPDATE_SET_ITEM_QUANTITY_SUCCESS,
              meta: {
                ...meta,
                ...extraMeta,
              },
              payload,
            };
          },
          UPDATE_SET_ITEM_QUANTITY_FAILURE,
        ],
        body: JSON.stringify({ quantity }),
      },
    });
  };
}

/** the replace endpoints are different from updateCartLineItem,  updateCartLineItem is only for applying membership token,
can't be used for updating colors and size, we are using the replace endpoint to do that */
export function updateCartItem(
  isProductSet,
  cartLineId,
  payload,
  isMultiple = false
) {
  const successAction = isMultiple
    ? UPDATE_CART_ITEMS_SUCCESS
    : UPDATE_CART_ITEM_SUCCESS;
  return async (dispatch, getState) =>
    dispatch({
      bentoApi: {
        endpoint: isProductSet
          ? `cart/sets/${cartLineId}/replace`
          : `cart/items/${cartLineId}/replace`,
        method: 'PUT',
        headers: getCustomHeaders(getState()),
        actions: [
          UPDATE_CART_ITEM_REQUEST,
          successAction,
          UPDATE_CART_ITEM_FAILURE,
        ],
        body: JSON.stringify({ quantity: 1, ...payload }),
      },
    });
}

export function deleteProductSet(
  groupKey,
  location,
  shouldRemoveMembership = false
) {
  return async (dispatch, getState) => {
    // Importing `checkoutFunctions` for jest spying
    const { deleteExpiredGwpItems } = checkoutFunctions;

    const { isVisitor } = getSession(getState());
    const isBorderfreeCustomer = getState().borderfree?.isBorderfreeCustomer;
    const meta = { location };
    const request = {
      bentoApi: {
        endpoint: `cart/sets/${groupKey}`,
        method: 'DELETE',
        headers: getCustomHeaders(getState()),
        actions: [
          DELETE_PRODUCT_SET_REQUEST,
          (payload, extraMeta) => {
            return {
              type: DELETE_PRODUCT_SET_SUCCESS,
              meta: {
                ...meta,
                ...extraMeta,
              },
              payload,
            };
          },
          DELETE_PRODUCT_SET_FAILURE,
        ],
      },
    };

    const result = await dispatch(request);

    if (shouldRemoveMembership && hasOnlyMembershipCartItem(getState())) {
      await dispatch(deleteMembershipFromCart({ location }));
    } else if (
      !isVisitor &&
      !isBorderfreeCustomer &&
      !getState().checkout?.useStoreCredit &&
      !hasPromoConflict(getState())
    ) {
      await dispatch(useStoreCredit(true));
    }

    await Promise.all([
      dispatch(deleteExpiredGwpItems()),
      dispatch(deleteForbiddenUnlockedXclusiveProducts()),
    ]);

    return result;
  };
}

export function addBasketItem(
  productId,
  quantity,
  meta,
  pSource,
  extraBodyParams = {}
) {
  return async (dispatch, getState) => {
    const state = getState();
    const isBorderfreeCustomer = state.borderfree?.isBorderfreeCustomer;
    const hadPromoConflict = hasPromoConflict(state);
    const { isVisitor } = getSession(state);
    const provider = isBorderfreeCustomer ? `borderfree` : `techstyle`;
    const request = {
      bentoApi: {
        endpoint: 'cart/items',
        method: 'POST',
        headers: getCustomHeaders(state),
        actions: [
          ADD_BASKET_ITEMS_REQUEST,
          (payload, extraMeta) => {
            return {
              type: ADD_BASKET_ITEMS_SUCCESS,
              meta: {
                productId,
                ...meta,
                ...extraMeta,
              },
              payload,
            };
          },
          ADD_BASKET_ITEMS_FAILURE,
        ],
        body: JSON.stringify({
          productId,
          quantity,
          provider,
          productSource: pSource,
          ...extraBodyParams,
        }),
      },
    };

    let result = null;
    try {
      [result] = await Promise.all([
        dispatch(request),
        dispatch(loadPromosIfVip()),
      ]);
      await dispatch(splitTest('AAmembershipatb'));
    } catch (err) {
      const responseBody = await err.originalError.response.json();
      const metaData = { productId };
      dispatch(trackAddToCartFailure(responseBody || {}, metaData));
      throw responseBody;
    }

    if (!isVisitor && !isBorderfreeCustomer) {
      const hasCashPromo = hasPromoConflict(getState());
      /** When creating new cart for new members we want usecreditstore set to true by default if it isn't cash promo**/
      const shouldUpdateUseStoreCredit =
        !getState().checkout?.useStoreCredit &&
        getMembership(getState()).storeCredits &&
        getMembership(getState()).storeCredits.length > 0 &&
        !hasCashPromo &&
        getState().checkout?.items.length === 1;
      /** If adding a product with cash promo but there were none before => default usestorecredit to applypromo**/
      if (!hadPromoConflict && hasCashPromo) {
        await dispatch(useStoreCredit(false));
      } else if (shouldUpdateUseStoreCredit) {
        await dispatch(useStoreCredit(true));
      }
    }
    return result;
  };
}

export function addFirstByoItem(productId, byoProductId, quantity, meta = {}) {
  return async (dispatch, getState) => {
    const isBorderfreeCustomer = getState().borderfree?.isBorderfreeCustomer;
    const provider = isBorderfreeCustomer ? `borderfree` : `techstyle`;
    return dispatch({
      bentoApi: {
        endpoint: 'cart/byo',
        method: 'POST',
        actions: [
          ADD_FIRST_BYO_ITEM_REQUEST,
          (payload, extraMeta) => {
            return {
              type: ADD_FIRST_BYO_ITEM_SUCCESS,
              meta: {
                productId,
                ...meta,
                ...extraMeta,
              },
              payload,
            };
          },
          {
            type: ADD_FIRST_BYO_ITEM_SUCCESS,
            meta,
          },
          ADD_FIRST_BYO_ITEM_FAILURE,
        ],
        body: JSON.stringify({
          productId,
          byoProductId,
          quantity,
          provider,
        }),
      },
    });
  };
}

export function addItemToByoSet(
  productId,
  byoProductId,
  byoGroupCode,
  quantity,
  meta = {}
) {
  return async (dispatch, getState) => {
    const isBorderfreeCustomer = getState().borderfree?.isBorderfreeCustomer;
    const provider = isBorderfreeCustomer ? `borderfree` : `techstyle`;
    return dispatch({
      bentoApi: {
        endpoint: `cart/byo/${byoGroupCode}`,
        method: 'POST',
        actions: [
          ADD_BYO_ITEM_REQUEST,
          (payload, extraMeta) => {
            return {
              type: ADD_BYO_ITEM_SUCCESS,
              meta: {
                productId,
                ...meta,
                ...extraMeta,
              },
              payload,
            };
          },
          {
            type: ADD_BYO_ITEM_SUCCESS,
            meta,
          },
          ADD_BYO_ITEM_FAILURE,
        ],
        body: JSON.stringify({
          productId,
          byoProductId,
          quantity,
          provider,
        }),
      },
    });
  };
}

export function addMembershipToCart(meta, productSource) {
  return (dispatch, getState) => {
    const state = getState();
    const productId = getDefaultMembershipProductId(state);
    if (meta.eventAction !== MembershipEventAction.AUTO_ADD) {
      dispatch(trackAddMembershipLine(meta));
    }
    return dispatch(
      addBasketItem(
        productId,
        1,
        { isModifyingMembership: true, ...meta },
        productSource,
        {
          productTypeId: ProductType.MEMBERSHIP_FEE_PLACEHOLDER,
        }
      )
    );
  };
}

function trackAddMembershipLine(meta) {
  return {
    type: TRACK_ADD_MEMBERSHIP_LINE,
    meta,
  };
}

function trackRemoveMembershipLine(meta) {
  return {
    type: TRACK_REMOVE_MEMBERSHIP_LINE,
    meta,
  };
}

export function trackPaymentMethodSelection(paymentType) {
  return {
    type: TRACK_PAYMENT_METHOD_SELECTION,
    paymentType,
  };
}
export function trackExpressCheckoutSelection(paymentType, category) {
  return {
    type: TRACK_EXPRESS_CHECKOUT_SELECTION,
    paymentType,
    category,
  };
}

export function trackAfterpaySelected() {
  return {
    type: TRACK_AFTERPAY_SELECTED,
    category: 'Checkout',
  };
}

export function trackKlarnaSelected() {
  return {
    type: TRACK_KLARNA_SELECTED,
    category: 'Checkout',
  };
}

export function trackEditShipping() {
  return {
    type: TRACK_EDIT_SHIPPING,
    category: 'Checkout',
  };
}

export function trackEditPayment() {
  return {
    type: TRACK_EDIT_PAYMENT,
    category: 'Checkout',
  };
}

export function deleteMembershipFromCart({ productId, location }) {
  return async (dispatch, getState) => {
    // Allow callers to pass no `productId` if they want to automatically remove
    // anything in the cart that counts as a membership.
    const removeAll = productId == null;
    const state = getState();

    let membershipItem = removeAll
      ? getMembershipCartItem(state)
      : { productId };

    // Don't blow up if consumers try to access `result.error`.
    let result = {};

    while (membershipItem) {
      const meta = {
        location,
      };
      const request = {
        bentoApi: {
          endpoint: `cart/products/${membershipItem.productId}`,
          method: 'DELETE',
          actions: [
            DELETE_MEMBERSHIP_ITEM_REQUEST,
            (payload, extraMeta) => {
              return {
                type: DELETE_MEMBERSHIP_ITEM_SUCCESS,
                meta: {
                  isModifyingMembership: true,
                  ...meta,
                  ...extraMeta,
                },
                payload,
              };
            },
            DELETE_MEMBERSHIP_ITEM_FAILURE,
          ],
        },
      };

      result = await dispatch(request);

      if (removeAll) {
        // Keep removing if there are more...
        membershipItem = getMembershipCartItem(getState());
      }
    }
    dispatch(trackRemoveMembershipLine({ location }));

    return result;
  };
}

export function updateItemQuantity(productId, quantity, location) {
  return async (dispatch, getState, context) => {
    const meta = { location };
    return dispatch({
      bentoApi: {
        endpoint: `cart/products/${productId}/quantity`,
        method: 'POST',
        headers: getCustomHeaders(getState()),
        actions: [
          UPDATE_ITEM_QUANTITY_REQUEST,
          (payload, extraMeta) => {
            return {
              type: UPDATE_ITEM_QUANTITY_SUCCESS,
              meta: {
                ...meta,
                ...extraMeta,
              },
              payload,
            };
          },
          UPDATE_ITEM_QUANTITY_FAILURE,
        ],
        body: JSON.stringify({ quantity }),
      },
    });
  };
}

export function deleteBasketItem(
  itemId,
  location,
  shouldRemoveMembership = false,
  componentLineId
) {
  return async (dispatch, getState) => {
    // Importing `checkoutFunctions` for jest spying
    const { deleteExpiredGwpItems } = checkoutFunctions;

    // Items from ECHO use UUID for cartLineId, so we check for it below
    const isCartLineId = new RegExp(
      /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i
    ).test(itemId);
    const { isVisitor } = getSession(getState());
    const isBorderfreeCustomer = getState().borderfree?.isBorderfreeCustomer;
    const meta = { location };
    let endpoint = `cart/items/${itemId}`;
    if (isCartLineId && componentLineId) {
      endpoint = `cart/byo/cartline/${itemId}/${componentLineId}`;
    } else if (isCartLineId && !componentLineId) {
      endpoint = `cart/cartline/${itemId}`;
    }
    const request = {
      bentoApi: {
        endpoint: endpoint,
        method: 'DELETE',
        headers: getCustomHeaders(getState()),
        actions: [
          DELETE_BASKET_ITEMS_REQUEST,
          (payload, extraMeta) => {
            return {
              type: DELETE_BASKET_ITEMS_SUCCESS,
              meta: {
                ...meta,
                ...extraMeta,
              },
              payload,
            };
          },
          DELETE_BASKET_ITEMS_FAILURE,
        ],
      },
    };

    const result = await dispatch(request);

    if (shouldRemoveMembership && hasOnlyMembershipCartItem(getState())) {
      await dispatch(deleteMembershipFromCart({ location }));
    } else if (
      !isVisitor &&
      !isBorderfreeCustomer &&
      !getState().checkout?.useStoreCredit &&
      !hasPromoConflict(getState())
    ) {
      await dispatch(useStoreCredit(true));
    }

    await Promise.all([
      dispatch(deleteExpiredGwpItems()),
      dispatch(deleteForbiddenUnlockedXclusiveProducts()),
    ]);

    return result;
  };
}

export function deleteBasketItemsByProductId(productId, location) {
  return async (dispatch, getState) => {
    // Importing `checkoutFunctions` for jest spying
    const { deleteExpiredGwpItems } = checkoutFunctions;

    const meta = { location };
    const request = {
      bentoApi: {
        endpoint: `cart/products/${productId}`,
        method: 'DELETE',
        headers: getCustomHeaders(getState()),
        actions: [
          DELETE_BASKET_ITEMS_BY_PRODUCT_ID_REQUEST,
          (payload, extraMeta) => {
            return {
              type: DELETE_BASKET_ITEMS_BY_PRODUCT_ID_SUCCESS,
              meta: {
                ...meta,
                ...extraMeta,
              },
              payload,
            };
          },
          DELETE_BASKET_ITEMS_BY_PRODUCT_ID_FAILURE,
        ],
      },
    };

    const result = await dispatch(request);

    await Promise.all([
      dispatch(deleteExpiredGwpItems()),
      dispatch(deleteForbiddenUnlockedXclusiveProducts()),
    ]);

    return result;
  };
}

export function updateCartLineItem(cartLineId, location, options = {}) {
  return async (dispatch, getState) => {
    const meta = { location };
    return dispatch({
      bentoApi: {
        endpoint: `cart/cartline/${cartLineId}`,
        method: 'PUT',
        headers: getCustomHeaders(getState()),
        body: JSON.stringify(options),
        actions: [
          UPDATE_CART_LINE_ITEM_REQUEST,
          (payload, extraMeta) => {
            return {
              type: UPDATE_CART_LINE_ITEM_SUCCESS,
              meta: {
                ...meta,
                ...extraMeta,
              },
              payload,
            };
          },
          UPDATE_CART_LINE_ITEM_FAILURE,
        ],
      },
    });
  };
}

export function updateFulfillmentProvider(provider) {
  return async (dispatch, getState, context) => {
    return dispatch({
      bentoApi: {
        endpoint: `cart/fulfillment`,
        method: 'POST',
        headers: getCustomHeaders(getState()),
        actions: [
          UPDATE_FULFILLMENT_PROVIDER_REQUEST,
          UPDATE_FULFILLMENT_PROVIDER_SUCCESS,
          UPDATE_FULFILLMENT_PROVIDER_FAILURE,
        ],
        body: JSON.stringify({ provider }),
      },
    });
  };
}

export function updateCartWithAddress(addressId, addressType = 'shipping') {
  return async (dispatch, getState, context) => {
    const { borderfree, checkout } = getState();
    const isBorderfreeCustomer = borderfree?.isBorderfreeCustomer;
    const provider = isBorderfreeCustomer ? `borderfree` : `techstyle`;
    const { items: checkoutItems = [] } = checkout;

    // Update the fullfillment as `borderfree` if we have items in the cart
    // and it's flagged as borderfree.
    if (checkoutItems.length > 0 && provider === `borderfree`) {
      dispatch(updateFulfillmentProvider(provider));
    }

    try {
      return await dispatch({
        bentoApi: {
          endpoint: `cart/addresses`,
          method: 'POST',
          headers: getCustomHeaders(getState()),
          actions: [
            UPDATE_CART_WITH_ADDRESS_REQUEST,
            UPDATE_CART_WITH_ADDRESS_SUCCESS,
            UPDATE_CART_WITH_ADDRESS_FAILURE,
          ],
          body: JSON.stringify({
            addressId: addressId,
            addressType,
          }),
        },
      });
    } catch (err) {
      // Track address update errors that could prevent checkout
      const enhancedError = getEnhancedError({
        err,
        functionName: 'updateCartWithAddress',
      });
      dispatch(trackCheckoutError(enhancedError, checkout?.cartId));
      throw err;
    }
  };
}

export function updateCartWithPayment(paymentMethod) {
  return async (dispatch, getState) => {
    const { checkout } = getState();
    try {
      if (!paymentMethod.paymentMethod && paymentMethod.paymentType) {
        paymentMethod.paymentMethod =
          paymentMethod.paymentType === 'creditcard' ? 'creditcard' : 'psp';
      }
      return await dispatch({
        bentoApi: {
          endpoint: `cart/payment`,
          method: 'POST',
          headers: getCustomHeaders(getState()),
          actions: [
            UPDATE_CART_WITH_PAYMENT_REQUEST,
            UPDATE_CART_WITH_PAYMENT_SUCCESS,
            UPDATE_CART_WITH_PAYMENT_FAILURE,
          ],
          body: JSON.stringify(paymentMethod),
        },
      });
    } catch (err) {
      // Track payment update errors that could prevent checkout
      const enhancedError = getEnhancedError({
        err,
        functionName: 'updateCartWithPayment',
      });
      dispatch(trackCheckoutError(enhancedError, checkout?.cartId));
      throw err;
    }
  };
}

/**
 * An action that will remember the user's in-progress payment information just
 * for the lifetime of the checkout flow, when necessary.
 */
export function cacheInProgressPayment(paymentType, paymentInfo) {
  return { type: CACHE_IN_PROGRESS_PAYMENT, paymentInfo };
}

export function clearInProgressPayment() {
  return { type: CLEAR_IN_PROGRESS_PAYMENT };
}

export function updateCartWithShipping(shippingOptionId) {
  return async (dispatch, getState) => {
    const { checkout } = getState();
    try {
      return await dispatch({
        bentoApi: {
          endpoint: `cart/shipping`,
          method: 'POST',
          actions: [
            UPDATE_CART_WITH_SHIPPING_REQUEST,
            UPDATE_CART_WITH_SHIPPING_SUCCESS,
            UPDATE_CART_WITH_SHIPPING_FAILURE,
          ],
          body: JSON.stringify({ shippingOptionId }),
        },
      });
    } catch (err) {
      // Track shipping update errors that could prevent checkout
      const enhancedError = getEnhancedError({
        err,
        functionName: 'updateCartWithShipping',
      });
      dispatch(trackCheckoutError(enhancedError, checkout?.cartId));
      throw err;
    }
  };
}

function initShippingInfo() {
  return async (dispatch, getState) => {
    const shippingInfo = getShippingInfo(getState());

    if (!shippingInfo.address.id) {
      await dispatch(loadAddresses());
      const defaultAddress = getDefaultAddress(getState());

      if (defaultAddress) {
        // Let's make sure the cart has the latest address attached to it
        await dispatch(updateCartWithAddress(defaultAddress.id, 'shipping'));
      } else {
        await dispatch(trackCheckoutStepChange('/checkout/shipping'));
        // Otherwise let's force the user to fill the address in
        return navigateToOrderSummary(1);
      }
    }

    // Apply a default shipping option, make sure they're still eligible,
    // etc.
    await dispatch(getShippingOptions());
    const shippingOptions = getFilteredShippingOptions(getState()) || [];
    const { shippingOptionId } = shippingInfo.shippingMethod;
    const savedShippingOption = shippingOptions.find(
      (option) => option.shippingOptionId === shippingOptionId
    );
    const { address } = getShippingInfo(getState());

    // Check if the saved shipping option still exists and it is valid for its zip
    if (!validateShippingOption(address, savedShippingOption)) {
      const defaultShippingOption = shippingOptions.length
        ? shippingOptions[0]
        : null;

      // Set a valid shipping option. Otherwise, redirect to address form
      if (validateShippingOption(address, defaultShippingOption)) {
        await dispatch(
          updateCartWithShipping(defaultShippingOption.shippingOptionId)
        );
      } else {
        return navigateToOrderSummary(2);
      }
    }
  };
}

const initPaymentInfo = () => {
  return async (dispatch, getState) => {
    let state = getState();
    let paymentInfo = getPaymentInfo(state);

    const useSavedPayment = true;
    let defaultPayment = getDefaultPaymentMethod(state);

    // If no payment method is attached to the cart, try to attach their
    // default payment method.
    if (
      !paymentInfo.paymentMethod.paymentId ||
      paymentInfo.paymentMethod.paymentMethod === 'psp'
    ) {
      if (useSavedPayment && !defaultPayment) {
        await dispatch(loadAccountPaymentMethods());
        state = getState();
        defaultPayment =
          getDefaultPaymentMethod(state) ||
          state.checkout?.inProgressPaymentInfo;
      }
      if (useSavedPayment && defaultPayment) {
        const addressId =
          defaultPayment.cardInfo && defaultPayment.cardInfo.addressId;

        if (!paymentInfo.address.id && addressId) {
          await dispatch(updateCartWithAddress(addressId, 'billing'));
          state = getState();
          paymentInfo = getPaymentInfo(state);
        }
        if (
          defaultPayment.paymentId &&
          paymentInfo.paymentMethod.paymentId !== defaultPayment.paymentId
        ) {
          await dispatch(
            updateCartWithPayment({
              paymentMethod: defaultPayment.paymentMethod,
              paymentId: defaultPayment.paymentId,
            })
          );
          state = getState();
          paymentInfo = getPaymentInfo(state);
        }
      } else {
        await dispatch(trackCheckoutStepChange('/checkout/payment'));
        return navigateToOrderSummary(2);
      }
    }

    // If there is a payment method attached, but its data hasn't been
    // fetched yet, do that now.
    if (
      (paymentInfo.paymentMethod.cardInfo &&
        paymentInfo.paymentMethod.cardInfo.incomplete) ||
      paymentInfo.paymentMethod.paymentType == null
    ) {
      await dispatch(loadAccountPaymentMethods());
      state = getState();
      paymentInfo = getPaymentInfo(state);
    }
    // If there's no payment address, and we have access to one, try to
    // attach that.
    if (!paymentInfo.address.id) {
      let addressId;
      if (
        paymentInfo.paymentMethod.cardInfo &&
        paymentInfo.paymentMethod.cardInfo.addressId
      ) {
        addressId = paymentInfo.paymentMethod.cardInfo.addressId;
      }
      if (
        paymentInfo.paymentMethod.sepaInfo &&
        paymentInfo.paymentMethod.sepaInfo.addressId
      ) {
        addressId = paymentInfo.paymentMethod.sepaInfo.addressId;
      } else if (
        paymentInfo.paymentMethod.paypalInfo &&
        paymentInfo.paymentMethod.paypalInfo.addressId
      ) {
        addressId = paymentInfo.paymentMethod.paypalInfo.addressId;
      }

      if (addressId) {
        await dispatch(updateCartWithAddress(addressId, 'billing'));
        state = getState();
        paymentInfo = getPaymentInfo(state);
      } else {
        await dispatch(trackCheckoutStepChange('/checkout/shipping'));
        return navigateToOrderSummary(1);
      }
    }
  };
};

export function initCheckout() {
  return async (dispatch, getState) => {
    const state = getState();
    const { checkout: cart, customer } = state;
    const hasCartId = cart?.cartId;

    if (!hasCartId) {
      // Ensure cart is loaded.
      await dispatch(loadCart());
    }

    // Ensure shipping info is loaded
    await dispatch(initShippingInfo());

    // Navigate to ordersummary step if user is influencer
    if (customer.isInfluencer) {
      navigateToOrderSummary(3);
    }

    const shippingInfo = getShippingInfo(getState());
    const { address, shippingMethod } = shippingInfo;
    const hasShippingInfo = address.id && shippingMethod?.shippingOptionId;
    if (hasShippingInfo) {
      await dispatch(initPaymentInfo());
    }

    const paymentInfo = getPaymentInfo(getState());
    const hasPaymentInfo = !!paymentInfo.address.id;
    if (hasShippingInfo && hasPaymentInfo) {
      await dispatch(trackCheckoutStepChange('/checkout/review-order'));
      return navigateToOrderSummary(3);
    }
  };
}

export function saveMondialAddress(address) {
  return async (dispatch, getState) => {
    const state = getState();
    const {
      address1,
      address2,
      city,
      countryCode,
      firstName,
      isPickupLocation,
      lastName,
      phone,
      providerLocationId,
      zip,
    } = address;

    dispatch(invalidateProfile());
    await dispatch(loadProfile());
    const email = state.customer && state.customer.email;

    return dispatch({
      bentoApi: {
        endpoint: `cart/shipping/retailpoint`,
        method: 'POST',
        body: JSON.stringify({
          address1: address1,
          address2: address2,
          city: city,
          countryCode: countryCode,
          email: email,
          firstName: firstName,
          isPickupLocation: isPickupLocation,
          lastName: lastName,
          locationId: providerLocationId,
          longDescription: '',
          phone: phone,
          shortDescription: '',
          zip: zip,
        }),
        actions: [
          SAVE_MONDIAL_ADDRESS_REQUEST,
          SAVE_MONDIAL_ADDRESS_SUCCESS,
          SAVE_MONDIAL_ADDRESS_FAILURE,
        ],
      },
    });
  };
}

export function deleteMondialAddress() {
  return async (dispatch, getState) => {
    return dispatch({
      bentoApi: {
        endpoint: `cart/shipping/retailpoint`,
        method: 'DELETE',
        actions: [
          DELETE_MONDIAL_ADDRESS_REQUEST,
          DELETE_MONDIAL_ADDRESS_SUCCESS,
          DELETE_MONDIAL_ADDRESS_FAILURE,
        ],
      },
    });
  };
}

export function completeCheckout() {
  return async (dispatch, getState) => {
    const state = getState();
    const { checkout: cart, customer } = state;
    let queryString = '';

    try {
      await dispatch(checkForBirthdayPromo());
    } catch (e) {
      // Do nothing. We're just making sure this doesn't mysteriously
      // throw an error during checkout since its only purpose is allowing
      // us to hide a birthday banner (aka not life or death).
    }

    await dispatch(loadMembership());
    if (customer.isInfluencer) {
      await dispatch(loadProfile());
    }
    if (cart?.order && cart?.order.isActivatingVip) {
      queryString = '?vipoptin=1';
    }
    await dispatch(splitTest('AAmembershipcheckout'));
    await dispatch(trackCheckoutStepChange('/checkout/order-complete'));
    return navigateToOrderConfirmation(queryString);
  };
}

export function checkForBirthdayPromo() {
  return async (dispatch, getState) => {
    const state = getState();
    const { checkout: cart } = state;

    // FIXME: remove this asset check as soon as the birthday promo AB test
    // is done and only one promo is being used (we can hard-code it then).
    const assets = await dispatch(loadAssets(['birthday_promo_codes']));
    const assetsArray =
      (assets.payload.birthday_promo_codes &&
        assets.payload.birthday_promo_codes.assets) ||
      [];
    const promoCodes = assetsArray.map((asset) =>
      asset.options.customVars.promoCode.toUpperCase()
    );
    const hasBirthdayPromo =
      cart?.order &&
      cart?.order.discounts &&
      cart?.order.discounts.some((discount) =>
        promoCodes.includes(discount.promoCode.toUpperCase())
      );
    if (hasBirthdayPromo) {
      const getDateNow = getDateNowFunction(state);
      await dispatch(
        updateCustomerDetail({
          name: 'birthday_promo_used',
          value: getDateNow(),
        })
      );
    }
  };
}

export function getShippingOptions({
  // If wanting to show unavailable shipping options due to a membership
  // promotion, set this to true.
  includeNonQualifying = false,
} = {}) {
  return async (dispatch, getState, context) => {
    const { checkout: cart } = getState();
    const shippingOptionsNetworkStatus = cart?.shippingOptionsNetworkStatus;

    if (!shippingOptionsNetworkStatus.isLoading) {
      return dispatch({
        bentoApi: {
          endpoint: 'cart/shipoptions',
          searchParams: {
            includeNonQualifying: includeNonQualifying,
          },
          requestKey: 'getShippingOptions',
          method: 'GET',
          headers: getCustomHeaders(getState()),
          actions: [
            GET_SHIPPING_OPTIONS_REQUEST,
            GET_SHIPPING_OPTIONS_SUCCESS,
            GET_SHIPPING_OPTIONS_FAILURE,
          ],
        },
      });
    }
  };
}

export async function navigateToOrderSummary(step) {
  await Router.push(`/checkout/order-information?step=${step}`, undefined, {
    shallow: true,
  });
}

export function navigateToOrderConfirmation(queryString) {
  Router.push(`/checkout/order-confirmation${queryString}`);
}

export function checkNewFreeTrialMember() {
  return (dispatch, getState) => {
    const state = getState();
    const newFreeTrialMember = hasFreeTrialMembershipInCart(state, {
      order: state.checkout?.order,
    });
    const email = state.customer && state.customer.email;
    if (newFreeTrialMember && email) {
      dispatch(subscribeNewFreeTrialMember({ email }));
    }
  };
}

export function changeDiscreetPackaging(params = {}) {
  return async (dispatch, getState) => {
    return dispatch({
      bentoApi: {
        endpoint: `cart/metadata`,
        body: JSON.stringify(params),
        method: 'PATCH',
        actions: [
          CHANGE_DISCREET_PACKAGING_REQUEST,
          CHANGE_DISCREET_PACKAGING_SUCCESS,
          CHANGE_DISCREET_PACKAGING_FAILURE,
        ],
      },
    });
  };
}

// this function is needed only to make testing easier
export function getSubmitCartOrderEndpoint(paymentProvider, paymentType) {
  const isAdyen = paymentProvider === 'adyen' && paymentType === 'creditcard';

  return isAdyen ? 'cart/purchase' : 'cart/order/submit';
}

function invalidateAfterSuccessfulCheckout({ isActivatingVip } = {}) {
  return async (dispatch, getState) => {
    dispatch(checkNewFreeTrialMember());
    // Always invalidate membership to get up to date membership credits
    dispatch(invalidateMembership());
    dispatch(invalidateMembershipPeriod());
    // When the member is activating we want to invalidate the membership status since
    // this will invalidate a bunch of other things related to segmenting the user
    if (isActivatingVip) {
      dispatch(updateMembershipStatusSuccess());

      // SXF updated terms to begin expiring member credits after 12 months for activating members.
      // Prior to this change, a customer detail record was added to target Builder content (i.e. Terms page)
      // for members who were members prior to the expiration period being implemented.
      // When this record exists and has a true value it needs to be set to false (or removed) once
      // activating membership again so they do not see outdated terms.
      // See: SXF-6527
      const preEmpMemberCreditExpirationValue = getCustomerDetail(
        getState(),
        'pre-emp_member_credit_expiration'
      ).value;
      if (preEmpMemberCreditExpirationValue) {
        dispatch(
          updateCustomerDetail({
            name: 'pre-emp_member_credit_expiration',
            value: false,
          })
        );
      }
    }
    // Invalidate the profile in case we are adding profile data during checkout (e.g. first time orders
    // for new accounts that might not have a profile w/ name yet)
    dispatch(invalidateProfile());
    dispatch(invalidateNavs());
    // This is needed to have the correct payment method for the order confirmation page since
    // the checkout step might have changed the payment method
    dispatch(loadAccountPaymentMethods());
    // Invalidate the mini cart data
    dispatch(invalidateCart());
  };
}

export function submitCartOrder(params = {}) {
  return async (dispatch, getState) => {
    const state = getState();
    const { checkout, storeGroup } = state;

    const endpoint = getSubmitCartOrderEndpoint(
      storeGroup.paymentOptions.paymentProvider,
      params.paymentType
    );

    const requestJSON = JSON.stringify({
      ...params,
      ...(endpoint === 'cart/order/submit'
        ? { deviceData: checkout?.deviceData }
        : {}),
    });

    const request = {
      bentoApi: {
        endpoint: endpoint,
        method: 'POST',
        headers: getCustomHeaders(getState()),
        body: requestJSON,
        retry: { retries: 0 },
        actions: [
          SUBMIT_CART_ORDER_REQUEST,
          SUBMIT_CART_ORDER_SUCCESS,
          SUBMIT_CART_ORDER_FAILURE,
        ],
      },
    };

    try {
      const result = await dispatch(request);

      if (
        result.payload &&
        result.payload.statusCode !== 202 &&
        !result.payload.adyenResponseType
      ) {
        // SUBMIT success above should no longer mean the order is complete.
        // Instead we dispatch this new action for consistency with payment
        // authorization flows.

        const oldMembership = getMembership(state);
        const { membershipDetail } = result.payload;
        const newMembership = getMembership({
          ...state,
          membership: membershipDetail,
        });
        const isActivatingVip = oldMembership.isLead && newMembership.isVip;
        result.payload.isActivatingVip = isActivatingVip;

        dispatch({
          ...result,
          type: COMPLETE_CART_ORDER_SUCCESS,
        });
        dispatch(invalidateAfterSuccessfulCheckout({ isActivatingVip }));
      }
      return result;
    } catch (err) {
      // Track the checkout error with cart details
      const enhancedError = getEnhancedError({
        err,
        functionName: 'submitCartOrder',
      });
      dispatch(trackCheckoutError(enhancedError, checkout?.cartId));

      // Re-throw the error to maintain existing behavior
      throw err;
    }
  };
}

export function completeCartOrder(params = {}, onAuthorizationStep = () => {}) {
  return async (dispatch, getState) => {
    const state = getState();
    const { isAdyen } = params;
    const { checkout } = state;

    const buildRequest = (requestParams) => {
      return {
        bentoApi: {
          endpoint: isAdyen ? 'cart/purchase/complete' : 'cart/order/complete',
          method: 'POST',
          headers: getCustomHeaders(getState()),
          body: JSON.stringify(requestParams),
          retry: { retries: 0 },
          actions: [
            COMPLETE_CART_ORDER_REQUEST,
            COMPLETE_CART_ORDER_SUCCESS,
            COMPLETE_CART_ORDER_FAILURE,
          ],
        },
      };
    };

    try {
      let result = await dispatch(buildRequest(params));

      // 3DS2 will sometimes require us to authenticate the user,
      // which we do here (and then resubmit with new authentication):
      if (
        result.payload.adyenResponseType === 'threeDS2Challenge' ||
        result.payload.adyenResponseType === 'redirect'
      ) {
        try {
          const newParams = await onAuthorizationStep(result.payload);
          result = await dispatch(buildRequest(newParams));
        } catch (authErr) {
          // Track authorization step error
          const enhancedError = getEnhancedError({
            err: authErr,
            functionName: 'completeCartOrder:threeDS2Challenge',
          });
          dispatch(trackCheckoutError(enhancedError, checkout?.cartId));
          throw authErr;
        }
      }

      const oldMembership = getMembership(state);
      const { membershipDetail } = result.payload;
      const newMembership = getMembership({
        ...state,
        membership: membershipDetail,
      });
      const isActivatingVip = oldMembership.isLead && newMembership.isVip;
      const resultCopy = cloneDeep(result);
      resultCopy.payload.isActivatingVip = isActivatingVip;

      if (isAdyen) {
        // call GTM for vip conversion for adyen checkout
        dispatch({
          ...resultCopy,
          type: COMPLETE_CART_ORDER_SUCCESS,
        });
      }

      dispatch(invalidateAfterSuccessfulCheckout({ isActivatingVip }));
      return resultCopy;
    } catch (err) {
      // Track the checkout error with cart details
      const enhancedError = getEnhancedError({
        err,
        functionName: 'completeCartOrder',
      });
      dispatch(trackCheckoutError(enhancedError, checkout?.cartId));
      throw err;
    }
  };
}

export function braintreePaypalCheckout(params) {
  return {
    bentoApi: {
      endpoint: 'cart/checkout/braintree/paypal/authorize',
      method: 'POST',
      body: JSON.stringify(params),
      retry: { retries: 0 },
      actions: [
        LOAD_BRAINTREE_REQUEST,
        LOAD_BRAINTREE_SUCCESS,
        LOAD_BRAINTREE_FAILURE,
      ],
    },
  };
}

export function setBraintreeDeviceData(deviceData) {
  return {
    type: SET_BRAINTREE_DEVICE_DATA,
    payload: { deviceData: deviceData },
  };
}

// Helper function to load promos only when a VIP for Gift With Purchase
function loadPromosIfVip() {
  return async (dispatch, getState) => {
    await dispatch(loadMembership());

    const state = getState();
    const { isVip } = getMembership(state);
    const promosRequest =
      isVip && !state?.promos?.promos?.length ? dispatch(loadPromos()) : null;

    await promosRequest;
  };
}

export function trackRegistrationPrompt() {
  return {
    type: TRACK_REGISTRATION_PROMPT_REQUEST,
  };
}

export function trackCheckoutStepChange(stepName) {
  return {
    type: TRACK_CHECKOUT_STEP,
    stepName,
  };
}

export function trackCheckoutToggle(eventAction) {
  return {
    type: TRACK_CHECKOUT_TOGGLE_REQUEST,
    eventAction,
  };
}

export function trackClaimGwpCta() {
  return {
    type: TRACK_CLAIM_GWP_CTA,
  };
}

export function trackAddGwp(productName) {
  return {
    type: TRACK_ADD_GWP,
    eventLabel: productName,
  };
}

export function trackRemoveGwp(productName) {
  return {
    type: TRACK_REMOVE_GWP,
    eventLabel: productName,
  };
}

export function trackUndoGwp() {
  return {
    type: TRACK_UNDO_GWP,
  };
}

export function trackSubmitOrderFailure(error) {
  return {
    type: TRACK_SUBMIT_ORDER_FAILURE,
    error,
  };
}

export function trackAddToCartFailure(error, meta) {
  return {
    type: TRACK_ADD_TO_CART_FAILURE,
    error,
    meta,
  };
}

export function trackAddSetToCartFailure(error, meta) {
  return {
    type: TRACK_ADD_SET_TO_CART_FAILURE,
    error,
    meta,
  };
}

export const TOGGLE_CART_DRAWER = 'TOGGLE_CART_DRAWER';

export const USE_STORE_CREDIT_REQUEST = 'USE_STORE_CREDIT_REQUEST';
export const USE_STORE_CREDIT_SUCCESS = 'USE_STORE_CREDIT_SUCCESS';
export const USE_STORE_CREDIT_FAILURE = 'USE_STORE_CREDIT_FAILURE';

export const APPLY_PROMO_CODE_REQUEST = 'APPLY_PROMO_CODE_REQUEST';
export const APPLY_PROMO_CODE_SUCCESS = 'APPLY_PROMO_CODE_SUCCESS';
export const APPLY_PROMO_CODE_FAILURE = 'APPLY_PROMO_CODE_FAILURE';

export const REMOVE_PROMO_CODE_REQUEST = 'REMOVE_PROMO_CODE_REQUEST';
export const REMOVE_PROMO_CODE_SUCCESS = 'REMOVE_PROMO_CODE_SUCCESS';
export const REMOVE_PROMO_CODE_FAILURE = 'REMOVE_PROMO_CODE_FAILURE';

export const EXPIRE_CART_REQUEST = 'EXPIRE_CART_REQUEST';
export const EXPIRE_CART_SUCCESS = 'EXPIRE_CART_SUCCESS';
export const EXPIRE_CART_FAILURE = 'EXPIRE_CART_FAILURE';

export const TRACK_PDP_LEARN_MORE_REQUEST = 'TRACK_PDP_LEARN_MORE_REQUEST';
export const TRACK_CLICK_PROMO_OFFER_REQUEST =
  'TRACK_CLICK_PROMO_OFFER_REQUEST';

export function toggleCartDrawer(isOpen, options = {}) {
  return (dispatch) => {
    if (options.fetchCart) {
      dispatch(loadCart());
    }

    return dispatch({
      type: TOGGLE_CART_DRAWER,
      payload: isOpen,
    });
  };
}

export function useStoreCredit(useStoreCredit) {
  return {
    bentoApi: {
      endpoint: 'cart/storecredit',
      method: 'POST',
      actions: [
        USE_STORE_CREDIT_REQUEST,
        USE_STORE_CREDIT_SUCCESS,
        USE_STORE_CREDIT_FAILURE,
      ],
      body: JSON.stringify({ useStoreCredit }),
    },
  };
}

export function applyPromoCode(promoCode) {
  return {
    bentoApi: {
      endpoint: 'cart/promocode',
      method: 'POST',
      actions: [
        APPLY_PROMO_CODE_REQUEST,
        APPLY_PROMO_CODE_SUCCESS,
        APPLY_PROMO_CODE_FAILURE,
      ],
      body: JSON.stringify({ promoCode }),
    },
  };
}

export function removePromoCode(promoCode) {
  return {
    bentoApi: {
      endpoint: `cart/promocode/${promoCode}`,
      method: 'DELETE',
      actions: [
        REMOVE_PROMO_CODE_REQUEST,
        REMOVE_PROMO_CODE_SUCCESS,
        REMOVE_PROMO_CODE_FAILURE,
      ],
    },
  };
}

export function updateCartStatus(status) {
  return {
    bentoApi: {
      endpoint: 'cart/status',
      method: 'POST',
      actions: [EXPIRE_CART_REQUEST, EXPIRE_CART_SUCCESS, EXPIRE_CART_FAILURE],
      body: JSON.stringify({ status }),
    },
  };
}

export function trackPDPLearnMoreEvent() {
  return {
    type: TRACK_PDP_LEARN_MORE_REQUEST,
  };
}

export function trackClickPromoOfferEvent(eventLabel) {
  return {
    type: TRACK_CLICK_PROMO_OFFER_REQUEST,
    eventLabel,
  };
}

export const TRACK_REMOVE_FROM_WISHLIST_REQUEST =
  'TRACK_REMOVE_FROM_WISHLIST_REQUEST';
export const TRACK_ADD_TO_WISHLIST_REQUEST = 'TRACK_ADD_TO_WISHLIST_REQUEST';

export function trackRemoveFromWishlistEvent({ eventLabel, eventCategory }) {
  return {
    type: TRACK_REMOVE_FROM_WISHLIST_REQUEST,
    payload: { eventLabel, eventCategory },
  };
}

export function trackAddToWishlistEvent({ eventLabel, eventCategory }) {
  return {
    type: TRACK_ADD_TO_WISHLIST_REQUEST,
    payload: { eventLabel, eventCategory },
  };
}

export const TRACK_QUICK_VIEW_MODAL_OPEN = 'TRACK_QUICK_VIEW_MODAL_OPEN';
export const TRACK_QUICK_VIEW_UPDATE_CART = 'TRACK_QUICK_VIEW_UPDATE_CART';
export const TRACK_QUICK_VIEW_ADD_TO_CART = 'TRACK_QUICK_VIEW_ADD_TO_CART';
export const TRACK_VIEW_CLICK_FULL_DETAILS = 'TRACK_VIEW_CLICK_FULL_DETAILS';
export const TRACK_QUICK_VIEW_CHANGE_PRODUCT_ATTRIBUTE =
  'TRACK_QUICK_VIEW_CHANGE_PRODUCT_ATTRIBUTE';

export const trackQuickViewModalOpen = (payload = {}) => ({
  type: TRACK_QUICK_VIEW_MODAL_OPEN,
  payload,
});

export const trackQuickViewUpdateCart = (payload = {}) => ({
  type: TRACK_QUICK_VIEW_UPDATE_CART,
  payload,
});

export const trackQuickViewAddToCart = (payload = '') => ({
  type: TRACK_QUICK_VIEW_ADD_TO_CART,
  payload,
});

export const trackQuickViewClickFullDetails = (payload = {}) => ({
  type: TRACK_VIEW_CLICK_FULL_DETAILS,
  payload,
});

export const trackQuickViewChangeProductAttribute = (payload = {}) => ({
  type: TRACK_QUICK_VIEW_CHANGE_PRODUCT_ATTRIBUTE,
  payload,
});

export const APPLY_MEMBERSHIP_PROMO_CODE_REQUEST =
  'APPLY_MEMBERSHIP_PROMO_CODE_REQUEST';
export const APPLY_MEMBERSHIP_PROMO_CODE_SUCCESS =
  'APPLY_MEMBERSHIP_PROMO_CODE_SUCCESS';
export const APPLY_MEMBERSHIP_PROMO_CODE_FAILURE =
  'APPLY_MEMBERSHIP_PROMO_CODE_FAILURE';

export function applyMembershipPromoCode(promo) {
  return {
    bentoApi: {
      endpoint: 'accounts/me/membership/promo',
      method: 'POST',
      actions: [
        APPLY_MEMBERSHIP_PROMO_CODE_REQUEST,
        APPLY_MEMBERSHIP_PROMO_CODE_SUCCESS,
        APPLY_MEMBERSHIP_PROMO_CODE_FAILURE,
      ],
      body: JSON.stringify(promo),
    },
  };
}

export const LOAD_REFERRER_REQUEST = 'LOAD_REFERRER_REQUEST';
export const LOAD_REFERRER_SUCCESS = 'LOAD_REFERRER_SUCCESS';
export const LOAD_REFERRER_FAILURE = 'LOAD_REFERRER_FAILURE';

export function loadReferrer() {
  return {
    bentoApi: {
      endpoint: `marketing/referrers`,
      method: 'GET',
      actions: [
        LOAD_REFERRER_REQUEST,
        LOAD_REFERRER_SUCCESS,
        LOAD_REFERRER_FAILURE,
      ],
    },
  };
}

export const LOAD_REVIEWS_REQUEST = 'LOAD_REVIEWS_REQUEST';
export const LOAD_REVIEWS_SUCCESS = 'LOAD_REVIEWS_SUCCESS';
export const LOAD_REVIEWS_FAILURE = 'LOAD_REVIEWS_FAILURE';

export const LOAD_SET_REVIEWS_REQUEST = 'LOAD_SET_REVIEWS_REQUEST';
export const LOAD_SET_REVIEWS_SUCCESS = 'LOAD_SET_REVIEWS_SUCCESS';
export const LOAD_SET_REVIEWS_FAILURE = 'LOAD_SET_REVIEWS_FAILURE';

export function loadReviews({
  groupCode,
  masterProductId,
  shouldUseCache,
  count = 5,
  page = 1,
  selectedProductSize,
  reviewSortCategory = ReviewSortCategories.HIGHEST_RATED,
  isSet = false,
  combineLinkedProduct = false,
}) {
  if (groupCode) {
    groupCode = String(groupCode).toUpperCase();
  }

  if (masterProductId) {
    masterProductId = Number(masterProductId);
  }

  const meta = {
    fetchedCount: count,
    fromCache: false,
    masterProductId,
    page,
    selectedProductSize,
    groupCode,
    reviewSortCategory,
  };

  const types = isSet
    ? [
        { type: LOAD_SET_REVIEWS_REQUEST, meta },
        { type: LOAD_SET_REVIEWS_SUCCESS, meta },
        { type: LOAD_SET_REVIEWS_FAILURE, meta },
      ]
    : [
        { type: LOAD_REVIEWS_REQUEST, meta },
        { type: LOAD_REVIEWS_SUCCESS, meta },
        { type: LOAD_REVIEWS_FAILURE, meta },
      ];

  return (dispatch, getState) => {
    const { reviews } = getState();

    // We are only returning cached data if the click is inside a PDP (i.e.
    // clicking between colorways). Individual products with the same reviews
    // will share the same `groupCode` while sets will share `masterProductId`.
    const isExistingProduct =
      (groupCode && reviews.groupCode === groupCode) ||
      (masterProductId && reviews.masterProductId === masterProductId);

    if (shouldUseCache && isExistingProduct) {
      return dispatch({
        type: LOAD_REVIEWS_SUCCESS,
        meta: { ...meta, fromCache: true },
      });
    }

    return dispatch({
      bentoApi: {
        endpoint: `products/${masterProductId}/reviews`,
        method: 'GET',
        searchParams: {
          count: count,
          productSize: selectedProductSize,
          sort:
            (reviewSortCategory === ReviewSortCategories.HIGHEST_RATED &&
              '-review_rating') ||
            (reviewSortCategory === ReviewSortCategories.LOWEST_RATED &&
              '+review_rating') ||
            (reviewSortCategory === ReviewSortCategories.MOST_RECENT &&
              '-review_timestamp,-review_rating'),
          page,
          combineLinkedProduct,
        },
        actions: types,
      },
    });
  };
}

export const TRACKING_UPDATE_LIST = 'TRACKING_UPDATE_LIST';
export const TRACKING_REMOVE_LIST = 'TRACKING_REMOVE_LIST';
export const TRACK_FILTER_REVIEWS = 'TRACK_FILTER_REVIEWS';
export const TRACK_PROMOTION_VIEWED = 'TRACK_PROMOTION_VIEWED';
export const TRACK_PROMOTION_CLICK = 'TRACK_PROMOTION_CLICK';
export const TRACK_BUTTON_CLICK = 'TRACK_BUTTON_CLICK';

export const updateTrackingList = (key, items) => {
  return {
    type: TRACKING_UPDATE_LIST,
    payload: {
      key,
      items,
    },
  };
};

export const removeTrackingList = (key) => {
  return {
    type: TRACKING_REMOVE_LIST,
    payload: { key },
  };
};

export const trackFilterReviews = (sortOption = null, filterBy = null) => {
  return {
    type: TRACK_FILTER_REVIEWS,
    payload: {
      filterBy,
      sortOption,
    },
  };
};

export const trackPromotionViewed = (payload) => {
  return {
    type: TRACK_PROMOTION_VIEWED,
    payload,
  };
};

export const trackPromotionClick = (payload) => {
  return {
    type: TRACK_PROMOTION_CLICK,
    payload,
  };
};

export const trackButtonClick = (payload) => {
  return {
    type: TRACK_BUTTON_CLICK,
    payload,
  };
};

export const LOAD_PRODUCTS_REQUEST = 'LOAD_PRODUCTS_REQUEST';
export const LOAD_PRODUCTS_SUCCESS = 'LOAD_PRODUCTS_SUCCESS';
export const LOAD_PRODUCTS_FAILURE = 'LOAD_PRODUCTS_FAILURE';

export const LOAD_PRODUCT_REQUEST = 'LOAD_PRODUCT_REQUEST';
export const LOAD_PRODUCT_SUCCESS = 'LOAD_PRODUCT_SUCCESS';
export const LOAD_PRODUCT_FAILURE = 'LOAD_PRODUCT_FAILURE';

export const LOAD_GIFTCARD_PRODUCT_REQUEST = 'LOAD_GIFTCARD_PRODUCT_REQUEST';
export const LOAD_GIFTCARD_PRODUCT_SUCCESS = 'LOAD_GIFTCARD_PRODUCT_SUCCESS';
export const LOAD_GIFTCARD_PRODUCT_FAILURE = 'LOAD_GIFTCARD_PRODUCT_FAILURE';

export const LOAD_PRODUCT_SET_REQUEST = 'LOAD_PRODUCT_SET_REQUEST';
export const LOAD_PRODUCT_SET_SUCCESS = 'LOAD_PRODUCT_SET_SUCCESS';
export const LOAD_PRODUCT_SET_FAILURE = 'LOAD_PRODUCT_SET_FAILURE';

export const LOAD_PRODUCT_ADDED_TO_BASKET_COUNT_REQUEST =
  'LOAD_PRODUCT_ADDED_TO_BASKET_COUNT_REQUEST';
export const LOAD_PRODUCT_ADDED_TO_BASKET_COUNT_SUCCESS =
  'LOAD_PRODUCT_ADDED_TO_BASKET_COUNT_SUCCESS';
export const LOAD_PRODUCT_ADDED_TO_BASKET_COUNT_FAILURE =
  'LOAD_PRODUCT_ADDED_TO_BASKET_COUNT_FAILURE';

export const TRACK_PRODUCT_IMPRESSION = 'TRACK_PRODUCT_IMPRESSION';

export const TRACK_PRODUCT_LIST_FILTER = 'TRACK_PRODUCT_LIST_FILTER';

export const TRACK_PRODUCT_LIST_VIEWED = 'TRACK_PRODUCT_LIST_VIEWED';

export const TRACK_PRODUCT_MODEL_NO_CHANGE = 'TRACK_PRODUCT_MODEL_NO_CHANGE';
export const TRACK_PRODUCT_MODEL_CHANGE = 'TRACK_PRODUCT_MODEL_CHANGE';
export const TRACK_PDP_MODEL_THUMBNAILS_CLICK =
  'TTRACK_PDP_MODEL_THUMBNAILS_CLICK';

export const TRACK_MODEL_COLLAPSIBLE_ACTION = 'TRACK_MODEL_COLLAPSIBLE_ACTION';

export const TRACK_PRODUCT_SEARCH_RESULT = 'TRACK_PRODUCT_SEARCH_RESULT';

export const TRACK_PRODUCT_SEARCH = 'TRACK_PRODUCT_SEARCH';

export const TRACK_MEMBERSHIP_CTA = 'TRACK_MEMBERSHIP_CTA';

export const TRACK_PDP_CROSS_SELL_CLICK = 'TRACK_PDP_CROSS_SELL_CLICK';
export const TRACK_PDP_RADIO_TOGGLE = 'TRACK_PDP_RADIO_TOGGLE';

export const TRACK_PDP_SET_SUMMARY_OPEN = 'TRACK_PDP_SET_SUMMARY_OPEN';
export const TRACK_PDP_SET_SUMMARY_CLOSE = 'TRACK_PDP_SET_SUMMARY_CLOSE';

export const TRACK_PDP_SET_DETAILS_OPEN = 'TRACK_PDP_SET_DETAILS_OPEN';
export const TRACK_PDP_SET_DETAILS_CLOSE = 'TRACK_PDP_SET_DETAILS_CLOSE';

export const TRACK_PDP_SET_REVIEWS_OPEN = 'TRACK_PDP_SET_REVIEWS_OPEN';
export const TRACK_PDP_SET_REVIEWS_CLOSE = 'TRACK_PDP_SET_REVIEWS_CLOSE';

export const TRACK_CLICK_SIZE_SELECTION = 'TRACK_CLICK_SIZE_SELECTION';

export const TRACK_PAIR_IT_WITH_CLICK = 'TRACK_PAIR_IT_WITH_CLICK';

export const TRACK_COMPLETE_THE_LOOK_CLICK = 'TRACK_COMPLETE_THE_LOOK_CLICK';

export const TRACK_PDP_SET_REVIEWS_PAGINATION =
  'TRACK_PDP_SET_REVIEWS_PAGINATION';

export const TRACK_COLOR_CHANGE = 'TRACK_COLOR_CHANGE';
export const TRACK_PDP_VIEW = 'TRACK_PDP_VIEW';
export const TRACK_PDP_VIDEO_PLAYBACK_STARTED =
  'TRACK_PDP_VIDEO_PLAYBACK_STARTED';
export const TRACK_PDP_VIDEO_PLAYBACK_COMPLETED =
  'TRACK_PDP_VIDEO_PLAYBACK_COMPLETED';
export const TRACK_GRID_PRODUCT_CELL_CLICK = 'TRACK_GRID_PRODUCT_CELL_CLICK';

export const TRACK_SIZE_CHANGE = 'TRACK_SIZE_CHANGE';

export const TRACK_VIEWED_PDP_IMAGE = 'TRACK_VIEWED_PDP_IMAGE';

export const TRACK_GRID_RECOMMENDATIONS = 'TRACK_GRID_RECOMMENDATIONS';

export const LOAD_PRODUCT_RECOMMENDATIONS_REQUEST =
  'LOAD_PRODUCT_RECOMMENDATIONS_REQUEST';
export const LOAD_PRODUCT_RECOMMENDATIONS_SUCCESS =
  'LOAD_PRODUCT_RECOMMENDATIONS_SUCCESS';
export const LOAD_PRODUCT_RECOMMENDATIONS_FAILURE =
  'LOAD_PRODUCT_RECOMMENDATIONS_FAILURE';

export const TRACK_PRODUCT_CLICK = 'TRACK_PRODUCT_CLICK';
export const TRACK_MARKETING_CARD_CLICK = 'TRACK_MARKETING_CARD_CLICK';

const THRESHOLD = 4;

export function loadProducts(
  filters = {},
  aggregations = false,
  options = { shouldCategorize: false, isFromFavorites: false }
) {
  return async (dispatch, getState, context) => {
    const state = getState();
    const { borderfree } = state;
    const { shouldCategorize } = options;
    const { shouldUseSuggestedProductsAlgo } = filters;
    const isFavoritesContext = options.isFromFavorites;
    const requestFilters = getStateDependentProductFilters(state, {
      filters,
      applyUserSizes: false,
      isFavoritesContext,
    });
    const requestParams = filtersToRequestParams({
      categorized: shouldCategorize,
      page: 1,
      includeOutOfStock: true,
      aggs: !!aggregations,
      ...requestFilters,
      size: 28, // Force size.
      excludePreorderProducts: borderfree.isBorderfreeCustomer ? true : null,
    });
    const requestKey = requestParamsToRequestKey(requestParams);
    const storeKey = requestParamsToStoreKey(requestParams);
    const aggregationKey = requestParamsToAggregationKey(requestParams);
    const meta = {
      categorized: shouldCategorize,
      requestParams,
      storeKey,
      requestKey,
      aggregationKey,
      fromCache: false,
    };

    let inflightProductsRequests = context.inflightProductsRequests || {};
    let request = inflightProductsRequests[requestKey];
    if (request) {
      return request;
    }

    const params = {
      ...requestParams,
    };

    const bentoApi = {};
    bentoApi.actions = [
      {
        type: LOAD_PRODUCTS_REQUEST,
        meta,
      },
      {
        type: LOAD_PRODUCTS_SUCCESS,
        meta,
      },
      {
        type: LOAD_PRODUCTS_FAILURE,
        meta,
      },
    ];

    bentoApi.endpoint =
      (shouldCategorize && `products/categorized`) ||
      (shouldUseSuggestedProductsAlgo && `accounts/me/products/suggested`) ||
      `products`;
    bentoApi.method = shouldCategorize ? 'POST' : 'GET';
    if (shouldCategorize) {
      bentoApi.body = JSON.stringify(params);
    } else if (shouldUseSuggestedProductsAlgo) {
      bentoApi.searchParams = {
        size: params.size,
        page: params.page,
      };
    } else {
      bentoApi.searchParams = params;
    }

    request = dispatch({ bentoApi });

    inflightProductsRequests = context.inflightProductsRequests = {
      ...inflightProductsRequests,
      [requestKey]: request,
    };

    const result = await request;
    inflightProductsRequests[requestKey] = undefined;

    return result;
  };
}

export function loadGiftcardProduct(id) {
  return async (dispatch) => {
    const searchParams = {
      combineLinkedProduct: true,
      ignoreWarehouse: true,
    };
    const result = await dispatch({
      bentoApi: {
        endpoint: `products/${id}`,
        searchParams,
        actions: [
          LOAD_GIFTCARD_PRODUCT_REQUEST,
          LOAD_GIFTCARD_PRODUCT_SUCCESS,
          LOAD_GIFTCARD_PRODUCT_FAILURE,
        ],
      },
    });

    return result;
  };
}

export function loadProduct(id, options = {}) {
  return async (dispatch) => {
    const searchParams = {
      combineLinkedProduct: true,
      includePromo: true,
      excludeSoldOutColors: true,
      ...options,
    };
    const result = await dispatch({
      bentoApi: {
        endpoint: `products/${id}`,
        searchParams,
        actions: [
          LOAD_PRODUCT_REQUEST,
          LOAD_PRODUCT_SUCCESS,
          LOAD_PRODUCT_FAILURE,
        ],
      },
    });

    return result;
  };
}

export function loadProductByPermalink(permalink, headers) {
  return async (dispatch) => {
    const result = await dispatch({
      bentoApi: {
        endpoint: `products/permalink/${permalink}`,
        headers,
        actions: [
          LOAD_PRODUCT_REQUEST,
          LOAD_PRODUCT_SUCCESS,
          LOAD_PRODUCT_FAILURE,
        ],
      },
    });

    return result;
  };
}

export function loadProductSet(id, options = {}) {
  return async (dispatch) => {
    const searchParams = {
      combineLinkedProduct: true,
      includePromo: true,
      excludeSoldOutColors: true,
      ...options,
    };
    const result = await dispatch({
      bentoApi: {
        endpoint: `products/sets/${id}`,
        searchParams,
        actions: [
          LOAD_PRODUCT_SET_REQUEST,
          LOAD_PRODUCT_SET_SUCCESS,
          LOAD_PRODUCT_SET_FAILURE,
        ],
      },
    });

    return result;
  };
}

// create a function for api request
export function loadRecommendedProducts(
  masterProductId,
  searchParams = { size: 10, includePromos: true }
) {
  return async (dispatch, getState) => {
    const { products } = getState();
    if (
      products.byMasterProductId[masterProductId] &&
      products.byMasterProductId[masterProductId].recommended
    ) {
      return dispatch({
        type: LOAD_PRODUCT_RECOMMENDATIONS_SUCCESS,
        meta: { masterProductId, fromCache: true },
        payload: {
          products: products.byMasterProductId[masterProductId].recommended,
        },
      });
    }
    return dispatch({
      bentoApi: {
        endpoint: `products/${masterProductId}/recommended`,
        searchParams,
        actions: [
          {
            type: LOAD_PRODUCT_RECOMMENDATIONS_REQUEST,
            meta: { masterProductId, fromCache: false },
          },
          {
            type: LOAD_PRODUCT_RECOMMENDATIONS_SUCCESS,
            meta: { masterProductId, fromCache: false },
          },
          {
            type: LOAD_PRODUCT_RECOMMENDATIONS_FAILURE,
            meta: { masterProductId, fromCache: false },
          },
        ],
      },
    });
  };
}

export function loadProductAddedToBasketCount(
  masterProductId,
  searchParams = { timeframe: 24 }
) {
  return async (dispatch, getState) => {
    if (masterProductId) {
      return dispatch({
        bentoApi: {
          endpoint: `products/${masterProductId}/metrics/atb-count`,
          method: 'GET',
          searchParams,
          actions: [
            {
              type: LOAD_PRODUCT_ADDED_TO_BASKET_COUNT_REQUEST,
              meta: { masterProductId, fromCache: false },
            },
            {
              type: LOAD_PRODUCT_ADDED_TO_BASKET_COUNT_SUCCESS,
              meta: { masterProductId, fromCache: false },
            },
            {
              type: LOAD_PRODUCT_ADDED_TO_BASKET_COUNT_FAILURE,
              meta: { masterProductId, fromCache: false },
            },
          ],
        },
      });
    }
  };
}

export function trackProductImpression({
  list,
  position,
  product,
  forceTrack = false,
  price,
  sessionId,
}) {
  return (dispatch, getState, context) => {
    context.trackProducts = context.trackProducts || [];
    const trackProduct = {
      list,
      position,
      product,
      price,
      sessionId,
    };

    context.trackProducts.push(trackProduct);

    if (forceTrack || context.trackProducts.length === THRESHOLD) {
      return dispatch({
        type: TRACK_PRODUCT_IMPRESSION,
        payload: context.trackProducts,
      });
    } else if (context.trackProducts.length > THRESHOLD) {
      // Reset array, but make sure to track the incoming product
      context.trackProducts = [trackProduct];
    }
  };
}

export function trackProductListViewed(payload) {
  return {
    type: TRACK_PRODUCT_LIST_VIEWED,
    payload,
  };
}

export function trackProductModelChange(model) {
  return {
    type: TRACK_PRODUCT_MODEL_CHANGE,
    model,
  };
}

export function trackProductModelNoChange() {
  return {
    type: TRACK_PRODUCT_MODEL_NO_CHANGE,
  };
}

export function trackPdpModelThumbnailsClick(model) {
  return {
    type: TRACK_PDP_MODEL_THUMBNAILS_CLICK,
    model,
  };
}

export function trackProductListFilter(payload) {
  return {
    type: TRACK_PRODUCT_LIST_FILTER,
    payload,
  };
}

export function trackModelCollapsibleAction(params) {
  return {
    type: TRACK_MODEL_COLLAPSIBLE_ACTION,
    payload: params,
  };
}

export function trackProductSearchResult(eventDetails) {
  return {
    type: TRACK_PRODUCT_SEARCH_RESULT,
    eventDetails,
  };
}

// to be used when acted upon a search query (even if not successful)
export function trackProductSearch(query) {
  return {
    type: TRACK_PRODUCT_SEARCH,
    query,
  };
}

export function trackMembershipCta(eventLabel) {
  return {
    type: TRACK_MEMBERSHIP_CTA,
    eventLabel,
  };
}

export function trackProductSetDetailsOpen() {
  return {
    type: TRACK_PDP_SET_DETAILS_OPEN,
  };
}

export function trackProductSetDetailsClose() {
  return {
    type: TRACK_PDP_SET_DETAILS_CLOSE,
  };
}

export function trackProductSetReviewsOpen() {
  return {
    type: TRACK_PDP_SET_REVIEWS_OPEN,
  };
}

export function trackProductSetReviewsClose() {
  return {
    type: TRACK_PDP_SET_REVIEWS_CLOSE,
  };
}

export function trackProductSetReviewsPagination(page) {
  return {
    type: TRACK_PDP_SET_REVIEWS_PAGINATION,
    page,
  };
}

export function trackPairItWithClick(eventLabel) {
  return {
    type: TRACK_PAIR_IT_WITH_CLICK,
    eventLabel,
  };
}

export function trackProductSetSummaryOpen() {
  return {
    type: TRACK_PDP_SET_SUMMARY_OPEN,
  };
}

export function trackProductSetSummaryClose() {
  return {
    type: TRACK_PDP_SET_SUMMARY_CLOSE,
  };
}

export function trackPdpRadioToggle(eventLabel) {
  return {
    type: TRACK_PDP_RADIO_TOGGLE,
    eventLabel,
  };
}

export function trackPdpCrossSellClick(eventLabel) {
  return {
    type: TRACK_PDP_CROSS_SELL_CLICK,
    eventLabel,
  };
}

export function trackGridRecommendations(eventLabel) {
  return {
    type: TRACK_GRID_RECOMMENDATIONS,
    eventLabel,
  };
}

export function trackClickSizeSelection(eventLabel) {
  return {
    type: TRACK_CLICK_SIZE_SELECTION,
    eventLabel,
  };
}

export function trackSizeChange(params) {
  return {
    type: TRACK_SIZE_CHANGE,
    payload: params,
  };
}

export function trackColorChange(params) {
  return {
    type: TRACK_COLOR_CHANGE,
    payload: params,
  };
}

export function trackViewedPdpImage(params) {
  return {
    type: TRACK_VIEWED_PDP_IMAGE,
    payload: params,
  };
}

export function trackPdpView(params) {
  return {
    type: TRACK_PDP_VIEW,
    payload: params,
  };
}

export function trackPdpVideoPlaybackStarted(params) {
  return {
    type: TRACK_PDP_VIDEO_PLAYBACK_STARTED,
    payload: params,
  };
}

export function trackPdpVideoPlaybackCompleted(params) {
  return {
    type: TRACK_PDP_VIDEO_PLAYBACK_COMPLETED,
    payload: params,
  };
}

export function trackGridProductCellClick(params) {
  return {
    type: TRACK_GRID_PRODUCT_CELL_CLICK,
    payload: params,
  };
}

export function trackProductClick(params) {
  return {
    type: TRACK_PRODUCT_CLICK,
    payload: params,
  };
}

export function trackMarketingCardClick(params) {
  return (dispatch) =>
    dispatch({
      type: TRACK_MARKETING_CARD_CLICK,
      payload: params,
    });
}

export const TRACK_MEMBERSHIP_LEARN_MORE = 'TRACK_MEMBERSHIP_LEARN_MORE';

export function trackMembershipLearnMore(location) {
  return {
    type: TRACK_MEMBERSHIP_LEARN_MORE,
    location,
  };
}

export const TOKENIZE_CREDIT_CARD_REQUEST = 'TOKENIZE_CREDIT_CARD_REQUEST';
export const TOKENIZE_CREDIT_CARD_SUCCESS = 'TOKENIZE_CREDIT_CARD_SUCCESS';
export const TOKENIZE_CREDIT_CARD_FAILURE = 'TOKENIZE_CREDIT_CARD_FAILURE';

export function tokenizeCreditCard(cardInfo, tokenizer = window.tfgtoken) {
  return (dispatch, getState) => {
    const { membership, storeGroup, checkout } = getState();

    dispatch({ type: TOKENIZE_CREDIT_CARD_REQUEST });

    const formData = {
      card_num: cardInfo.cardNum,
      card_code: cardInfo.cardCode,
      name_on_card: cardInfo.nameOnCard,
      exp_month: cardInfo.expMonth,
      exp_year: cardInfo.expYear,
      store_group_id: storeGroup.storeGroupId,
      customer_id: membership.customerId,
    };

    return new Promise((resolve) => {
      const onSuccess = (outputForm) => {
        const outputData = tokenizer.serializeObject(outputForm);
        resolve(
          dispatch({
            type: TOKENIZE_CREDIT_CARD_SUCCESS,
            payload: {
              cardBin: outputData.card_bin,
              cardGateway: outputData.card_gateway,
              cardNum: outputData.card_token,
              cardCode: outputData.card_code,
              cardType: outputData.card_type,
              customerId: parseInt(outputData.customer_id, 10),
              storeGroupId: parseInt(outputData.store_group_id, 10),
            },
          })
        );
      };
      const onError = (err) => {
        // We could use `reject` here, but it would be inconsistent with the
        // way other API calls surface errors.
        // Track credit card tokenization failures as checkout errors
        const enhancedError = getEnhancedError({
          err,
          functionName: 'tokenizeCreditCard',
        });
        dispatch(trackCheckoutError(enhancedError, checkout?.cartId));
        resolve(
          dispatch({
            type: TOKENIZE_CREDIT_CARD_FAILURE,
            error: true,
            payload: enhancedError,
          })
        );
      };
      tokenizer.postToTokenServer(formData, onSuccess, onError);
    });
  };
}

export const UPDATE_DEBUG_FLAGS = 'UPDATE_DEBUG_FLAGS';

export function updateDebugFlags(flags) {
  return { type: UPDATE_DEBUG_FLAGS, flags };
}
export const LOAD_ADDRESSES_REQUEST = 'LOAD_ADDRESSES_REQUEST';
export const LOAD_ADDRESSES_SUCCESS = 'LOAD_ADDRESSES_SUCCESS';
export const LOAD_ADDRESSES_FAILURE = 'LOAD_ADDRESSES_FAILURE';

export const CREATE_ADDRESS_REQUEST = 'CREATE_ADDRESS_REQUEST';
export const CREATE_ADDRESS_SUCCESS = 'CREATE_ADDRESS_SUCCESS';
export const CREATE_ADDRESS_FAILURE = 'CREATE_ADDRESS_FAILURE';

export const UPDATE_ADDRESS_REQUEST = 'UPDATE_ADDRESS_REQUEST';
export const UPDATE_ADDRESS_SUCCESS = 'UPDATE_ADDRESS_SUCCESS';
export const UPDATE_ADDRESS_FAILURE = 'UPDATE_ADDRESS_FAILURE';

export const DELETE_ADDRESS_REQUEST = 'DELETE_ADDRESS_REQUEST';
export const DELETE_ADDRESS_SUCCESS = 'DELETE_ADDRESS_SUCCESS';
export const DELETE_ADDRESS_FAILURE = 'DELETE_ADDRESS_FAILURE';

export const VALIDATE_ADDRESS_REQUEST = 'VALIDATE_ADDRESS_REQUEST';
export const VALIDATE_ADDRESS_SUCCESS = 'VALIDATE_ADDRESS_SUCCESS';
export const VALIDATE_ADDRESS_FAILURE = 'VALIDATE_ADDRESS_FAILURE';

export function validateAddress({
  address1,
  address2,
  city,
  state,
  zip,
  zipExt,
  countryCode,
}) {
  return {
    bentoApi: {
      endpoint: 'accounts/me/address/verify',
      method: 'POST',
      body: JSON.stringify({
        address1,
        address2,
        city,
        state,
        zip,
        zipExt: zipExt || '',
        countryCode,
      }),
      actions: [
        VALIDATE_ADDRESS_REQUEST,
        VALIDATE_ADDRESS_SUCCESS,
        VALIDATE_ADDRESS_FAILURE,
      ],
    },
  };
}

export function loadAddresses() {
  return (dispatch, getState) => {
    const { account } = getState();
    if (!account.addresses.networkStatus.isLoading) {
      return dispatch({
        bentoApi: {
          endpoint: 'accounts/me/addresses',
          actions: [
            LOAD_ADDRESSES_REQUEST,
            LOAD_ADDRESSES_SUCCESS,
            LOAD_ADDRESSES_FAILURE,
          ],
        },
      });
    }
  };
}

export function createAddress(address) {
  return {
    bentoApi: {
      endpoint: 'accounts/me/addresses',
      method: 'POST',
      body: JSON.stringify({
        type: 'shipping',
        phone: '',
        email: '',
        address2: '',
        state: address.countryCode === 'US' ? '' : '--',
        ...address,
      }),
      actions: [
        CREATE_ADDRESS_REQUEST,
        CREATE_ADDRESS_SUCCESS,
        CREATE_ADDRESS_FAILURE,
      ],
    },
  };
}

export function updateAddress(address) {
  return {
    bentoApi: {
      endpoint: `accounts/me/addresses/${address.id}`,
      method: 'POST',
      body: JSON.stringify(address),
      actions: [
        UPDATE_ADDRESS_REQUEST,
        UPDATE_ADDRESS_SUCCESS,
        UPDATE_ADDRESS_FAILURE,
      ],
    },
  };
}

export function setDefaultAddress(address) {
  const meta = { defaultUpdated: true };
  return {
    bentoApi: {
      endpoint: `accounts/me/addresses/${address.id}`,
      method: 'POST',
      body: JSON.stringify({
        type: 'shipping',
        ...address,
        isDefault: true,
        applyCartShipAddress: true,
      }),
      actions: [
        UPDATE_ADDRESS_REQUEST,
        (payload, extraMeta) => {
          payload = {
            ...address,
            ...payload,
            isDefault: true,
          };

          return {
            type: UPDATE_ADDRESS_SUCCESS,
            meta: {
              ...meta,
              ...extraMeta,
            },
            payload,
          };
        },
        UPDATE_ADDRESS_FAILURE,
      ],
    },
  };
}

export function deleteAddress(address) {
  return {
    bentoApi: {
      endpoint: `accounts/me/addresses/${address.id}`,
      method: 'DELETE',
      actions: [
        DELETE_ADDRESS_REQUEST,
        (payload, meta) => ({
          type: DELETE_ADDRESS_SUCCESS,
          payload: address,
          meta,
        }),
        DELETE_ADDRESS_FAILURE,
      ],
    },
  };
}

export const GET_BYO_CONFIG_REQUEST = 'GET_BYO_CONFIG_REQUEST';
export const GET_BYO_CONFIG_SUCCESS = 'GET_BYO_CONFIG_SUCCESS';
export const GET_BYO_CONFIG_FAILURE = 'GET_BYO_CONFIG_FAILURE';

export function getByoSetsConfig() {
  return {
    bentoApi: {
      endpoint: `products/byo/config?filterInactiveConfigs=true`,
      method: 'GET',
      actions: [
        GET_BYO_CONFIG_REQUEST,
        GET_BYO_CONFIG_SUCCESS,
        GET_BYO_CONFIG_FAILURE,
      ],
    },
  };
}
export const CHECK_IS_PASSWORDLESS_LOGIN_REQUEST =
  'CHECK_IS_PASSWORDLESS_LOGIN_REQUEST';
export const CHECK_IS_PASSWORDLESS_LOGIN_SUCCESS =
  'CHECK_IS_PASSWORDLESS_LOGIN_SUCCESS';
export const CHECK_IS_PASSWORDLESS_LOGIN_FAILURE =
  'CHECK_IS_PASSWORDLESS_LOGIN_FAILURE';

export function checkIfPasswordlessLogin(params) {
  const { email, alKey, alToken } = params ?? {};

  return {
    bentoApi: {
      endpoint: 'members/is-passwordless',
      searchParams: { email, alKey, alToken },
      actions: [
        CHECK_IS_PASSWORDLESS_LOGIN_REQUEST,
        CHECK_IS_PASSWORDLESS_LOGIN_SUCCESS,
        CHECK_IS_PASSWORDLESS_LOGIN_FAILURE,
      ],
    },
  };
}

export const TOGGLE_SIGN_IN_MODAL = 'TOGGLE_SIGN_IN_MODAL';

export function toggleSignInModal(
  isOpen,
  initialScreen,
  location,
  productId,
  isProductSet
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: TOGGLE_SIGN_IN_MODAL,
        payload: isOpen,
        initialScreen: initialScreen || 'SIGN_IN',
        onSuccess: resolve,
        onCancel: reject,
        meta: { location, productId, isProductSet },
      });
    });
  };
}

export const LOAD_ORDER_REQUEST = 'LOAD_ORDER_REQUEST';
export const LOAD_ORDER_SUCCESS = 'LOAD_ORDER_SUCCESS';
export const LOAD_ORDER_FAILURE = 'LOAD_ORDER_FAILURE';

export function loadOrder(orderId) {
  return async (dispatch, getState) => {
    const { membership } = getState();

    return dispatch({
      bentoApi: {
        endpoint: `accounts/me/orders/${orderId}`,
        method: 'GET',
        actions: [
          { type: LOAD_ORDER_REQUEST },
          (payload, meta) => {
            if (payload.customerId !== membership.customerId) {
              // Temporary. See FIS-150
              const error = new Error('unauthorized');
              error.statusCode = 403;
              throw error;
            }

            return {
              type: LOAD_ORDER_SUCCESS,
              meta,
              payload,
            };
          },
          { type: LOAD_ORDER_FAILURE },
        ],
      },
    });
  };
}

export const ADD_ACCOUNT_PAYMENT_METHOD_REQUEST =
  'ADD_ACCOUNT_PAYMENT_METHOD_REQUEST';
export const ADD_ACCOUNT_PAYMENT_METHOD_SUCCESS =
  'ADD_ACCOUNT_PAYMENT_METHOD_SUCCESS';
export const ADD_ACCOUNT_PAYMENT_METHOD_FAILURE =
  'ADD_ACCOUNT_PAYMENT_METHOD_FAILURE';

// NOTE: `paymentType` is neither a provided nor a payment method, it's a
// confusing mix of either...
export function addAccountPaymentMethod(paymentType, params) {
  let endpoint = 'accounts/me/payments';
  if (paymentType !== 'vantiv') {
    endpoint += `/${paymentType}`;
  }
  return {
    bentoApi: {
      endpoint,
      method: 'POST',
      actions: [
        ADD_ACCOUNT_PAYMENT_METHOD_REQUEST,
        ADD_ACCOUNT_PAYMENT_METHOD_SUCCESS,
        ADD_ACCOUNT_PAYMENT_METHOD_FAILURE,
      ],
      body: JSON.stringify(params),
    },
  };
}

export const JOIN_EMAIL_LIST_REQUEST = 'JOIN_EMAIL_LIST_REQUEST';
export const JOIN_EMAIL_LIST_SUCCESS = 'JOIN_EMAIL_LIST_SUCCESS';
export const JOIN_EMAIL_LIST_FAILURE = 'JOIN_EMAIL_LIST_FAILURE';

export function subscribe({ email, optOutStatus }) {
  return async (dispatch, getState) => {
    const { domain } = getState();

    const marketingList = config.get('public.sailthru.marketingLists')[
      domain.tld
    ];
    const marketingLists = marketingList ? [marketingList] : [];
    /** optOutStatus values:
     * "Always" must be sent as 'none' with an email_cadence: 0
     * "Sometimes" must be sent as 'none' with an email_cadence: 1
     * "Never" must be sent as 'basic' with an email_cadence: 0
     */
    let status;
    let emailCadence;
    switch (optOutStatus) {
      case 'never':
        status = 'basic';
        emailCadence = 0;
        break;
      case 'sometimes':
        status = 'none';
        emailCadence = 1;
        break;
      case 'always':
        status = 'none';
        emailCadence = 0;
        break;
    }
    const result = await dispatch({
      bentoApi: {
        endpoint: 'contacts',
        method: 'POST',
        body: JSON.stringify({
          email,
          optOutStatus: status,
          marketingLists,
          attributes: {
            email_cadence: emailCadence,
          },
        }),
        actions: [
          JOIN_EMAIL_LIST_REQUEST,
          JOIN_EMAIL_LIST_SUCCESS,
          JOIN_EMAIL_LIST_FAILURE,
        ],
      },
    });
    return result;
  };
}

export const TRACK_REGISTRATION_FAILURE = 'TRACK_REGISTRATION_FAILURE';

export function trackRegistrationFailure(error, source = null) {
  return {
    type: TRACK_REGISTRATION_FAILURE,
    error,
    source,
  };
}

export const TRACK_ACCOUNT_SEGMENT_EVENTS = 'TRACK_ACCOUNT_SEGMENT_EVENTS';

export function trackAccountSegmentEvents() {
  return async (dispatch, getState, context) => {
    await Promise.all([
      dispatch(loadAddresses()),
      dispatch(loadMembership()),
      dispatch(loadProfile()),
    ]);
    const state = getState();

    const { customer: profile, account } = state;
    const { profile: profileBirthday } = profile;

    const { addresses } = account;
    const zipCode =
      addresses?.data && addresses.data.length > 0 ? addresses.data[0].zip : '';

    const { isPaygo, membershipLevelGroup } = getMembership(state);
    const membershipStatus = isPaygo ? 'Payg' : membershipLevelGroup;

    const {
      'birth-day': birthDay,
      'birth-month': birthMonth,
      'birth-year': birthYear,
    } = profileBirthday || {};

    const birthday =
      birthDay && birthMonth && birthYear
        ? `${birthMonth}-${birthDay}-${birthYear}`
        : '';

    return dispatch({
      type: TRACK_ACCOUNT_SEGMENT_EVENTS,
      payload: { profile, zipCode, birthday, membershipStatus },
    });
  };
}

export const ADD_KLARNA_ACCOUNT_PAYMENT_METHOD_REQUEST =
  'ADD_KLARNA_ACCOUNT_PAYMENT_METHOD_REQUEST';
export const ADD_KLARNA_ACCOUNT_PAYMENT_METHOD_SUCCESS =
  'ADD_KLARNA_ACCOUNT_PAYMENT_METHOD_SUCCESS';
export const ADD_KLARNA_ACCOUNT_PAYMENT_METHOD_FAILURE =
  'ADD_KLARNA_ACCOUNT_PAYMENT_METHOD_FAILURE';

export function addKlarnaAccountPaymentMethod(params) {
  return {
    bentoApi: {
      endpoint: 'accounts/me/payments/klarna',
      method: 'POST',
      actions: [
        ADD_KLARNA_ACCOUNT_PAYMENT_METHOD_REQUEST,
        ADD_KLARNA_ACCOUNT_PAYMENT_METHOD_SUCCESS,
        ADD_KLARNA_ACCOUNT_PAYMENT_METHOD_FAILURE,
      ],
      body: JSON.stringify(params),
    },
  };
}

export const TRACK_REGISTRATION_PROMPT_SIGN_UP =
  'TRACK_REGISTRATION_PROMPT_SIGN_UP';

export function trackRegistrationSignUp(eventAction) {
  return {
    type: TRACK_REGISTRATION_PROMPT_SIGN_UP,
    eventAction,
  };
}

export const SIGN_UP_METHOD_SUCCESS = 'SIGN_UP_METHOD_SUCCESS';

export function trackSignUpMethod(eventAction) {
  return {
    type: SIGN_UP_METHOD_SUCCESS,
    eventAction,
  };
}

export const TRACK_SIGN_UP_MODAL = 'TRACK_SIGN_UP_MODAL';

export function trackSignUpModal(location) {
  return {
    type: TRACK_SIGN_UP_MODAL,
    location,
  };
}

export const TRACK_IDENTIFY_QUIZ_TRAITS = 'TRACK_IDENTIFY_QUIZ_TRAITS';

// Can be removed once new prodcut quiz modal takes over
export function trackIdentifyQuizTraits({ quizDetails, profile }) {
  return async (dispatch, getState, context) => {
    await dispatch(loadProfile());
    const state = getState();
    const {
      customer: {
        profile: { 'membership-id': id },
      },
    } = state;

    const quizTraits = quizDetails.reduce((traitObj, answer) => {
      return { ...traitObj, [answer.name]: answer.value };
    }, {});

    const traits = {
      ...quizTraits,
      ...profile,
    };

    return dispatch({
      type: TRACK_IDENTIFY_QUIZ_TRAITS,
      payload: { traits, id },
    });
  };
}

export function signUp({
  firstName = '',
  lastName = '',
  email,
  password,
  optOutStatus,
  quizDetails,
  profile,
  method = SignUpMethod.SIGN_UP,
  details = {},
}) {
  return async (dispatch, getState) => {
    const { domain } = getState();
    const marketingList = config.get('public.sailthru.marketingLists')[
      domain.tld
    ];
    const marketingLists = marketingList ? [marketingList] : [];
    const meta = { method };

    const membershipTypeId = 1;

    let signupMethod;
    switch (meta.method) {
      case 'CARTDRAWER':
        signupMethod = { signup_source: 'checkout' };
        break;
      case 'CART_CHECKOUT':
        signupMethod = { signup_source: 'cart' };
        break;
      case 'EXIT':
        signupMethod = { signup_source: 'exit' };
        break;
      case 'FAVORITES':
        signupMethod = { signup_source: 'favorites_nav' };
        break;
      case 'LIVE_SHOPPING':
        signupMethod = { signup_source: 'live_shopping' };
        break;
      case 'NAVBAR':
        signupMethod = { signup_source: 'login' };
        break;
      case 'NEWSLETTER_EMAIL_SIGNUP':
        signupMethod = { signup_source: 'email_signup' };
        break;
      case 'QUIZ':
        signupMethod = { signup_source: 'quiz' };
        break;
      case 'SIGN_IN':
        signupMethod = { signup_source: 'signin' };
        break;
      case 'SIGN_IN_PAGE':
        signupMethod = { signup_source: 'sign_in_page' };
        break;
      case 'SIZE_FILTERS':
        signupMethod = { signup_source: 'size_filters' };
        break;
      case 'SPEEDY':
        signupMethod = { signup_source: 'speedy' };
        break;
      case 'WAITLIST':
        signupMethod = { signup_source: 'waitlist' };
        break;
      case 'WISHLIST':
        signupMethod = { signup_source: 'wishlist' };
        break;
    }

    details = { ...details, ...signupMethod, ...profile };

    const payload = {
      firstName,
      lastName,
      email,
      password,
      optOutStatus,
      marketingLists,
      membershipTypeId,
      quizDetails,
      details,
    };

    const result = await dispatch(baseSignUp(payload, { method }));
    await dispatch(loadCustomerDetails(['signup_source']));
    dispatch(splitTest('AAsessionregistrationcomplete'));

    let isFirstTimeSignUp = true;
    // We only want to track the first time a user signs up, if they are a returning passwordless
    // lead, we do not want to track them as a new sign up. The signup endpoint will return a flag
    // `isPasswordlessLead` if the user is a returning passwordless lead, this flag is not present
    // the first time going through guest checkout.
    if (result?.payload.customer.optionSignatures?.isPasswordlessLead) {
      isFirstTimeSignUp = false;
    }

    if (isFirstTimeSignUp) {
      dispatch(trackSignUpMethod(meta));
    }

    return result;
  };
}

export const VIP_BOX_SUBSCRIPTION_REQUEST = 'VIP_BOX_SUBSCRIPTION_REQUEST';
export const VIP_BOX_SUBSCRIPTION_SUCCESS = 'VIP_BOX_SUBSCRIPTION_SUCCESS';
export const VIP_BOX_SUBSCRIPTION_FAILURE = 'VIP_BOX_SUBSCRIPTION_FAILURE';

export function subscribeVipBoxNotification({ email, attributes }) {
  return async (dispatch, getState) => {
    const state = getState();
    const getNewDate = getNewDateFunction(state);
    // Each month create a new VIP box marketing list
    const now = getNewDate();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const vipBoxList = `${year}_${month}_Xtra_VIP_Box`;
    const masterMarketingList = config.get('public.sailthru.marketingLists')[
      state.domain.tld
    ];
    const marketingLists = [masterMarketingList, vipBoxList];

    const result = await dispatch({
      bentoApi: {
        endpoint: 'contacts',
        method: 'POST',
        body: JSON.stringify({
          email,
          marketingLists,
          attributes,
        }),
        actions: [
          VIP_BOX_SUBSCRIPTION_REQUEST,
          VIP_BOX_SUBSCRIPTION_SUCCESS,
          VIP_BOX_SUBSCRIPTION_FAILURE,
        ],
      },
    });
    return result;
  };
}

export const LOAD_RETURNS_SETTINGS_REQUEST = 'LOAD_RETURNS_SETTINGS_REQUEST';
export const LOAD_RETURNS_SETTINGS_SUCCESS = 'LOAD_RETURNS_SETTINGS_SUCCESS';
export const LOAD_RETURNS_SETTINGS_FAILURE = 'LOAD_RETURNS_SETTINGS_FAILURE';

export function loadOrderReturnsSettings() {
  return {
    bentoApi: {
      endpoint: `settings/returns`,
      method: 'GET',
      actions: [
        LOAD_RETURNS_SETTINGS_REQUEST,
        LOAD_RETURNS_SETTINGS_SUCCESS,
        LOAD_RETURNS_SETTINGS_FAILURE,
      ],
    },
  };
}

export const GENERATE_RMA_REQUEST = 'GENERATE_RMA_REQUEST';
export const GENERATE_RMA_SUCCESS = 'GENERATE_RMA_SUCCESS';
export const GENERATE_RMA_FAILURE = 'GENERATE_RMA_FAILURE';

export const LOAD_ORDERS_REQUEST = 'LOAD_ORDERS_REQUEST';
export const LOAD_ORDERS_SUCCESS = 'LOAD_ORDERS_SUCCESS';
export const LOAD_ORDERS_FAILURE = 'LOAD_ORDERS_FAILURE';

export function trackCheckoutError(error, cartId) {
  const errorDetails =
    typeof error === 'object' ? { ...error } : { message: error };

  return {
    type: TRACK_CHECKOUT_ERROR,
    error,
    cartId,
    errorDetails,
  };
}
